import React, { useState, useEffect } from "react";
import {
  Container,
  Button,
  Spinner,
  Card,
  Form,
  Row,
  Col,
  Image,
  Tabs,
  Tab,
  Dropdown,
  Table,
  Modal,
} from "react-bootstrap";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import { userService } from '../services/userService';
import { accountService } from '../services/accountService';
import { reportsService } from '../services/reportsService';
import { urlService } from '../services/urlService';
import { creditService } from '../services/creditService';
import connectorService from '../services/connectorService';
import {
  FaCalendarAlt,
  FaEllipsisV,
  FaSort,
  FaSortUp,
  FaSortDown,
  FaArrowRight,
} from "react-icons/fa";
import { CiCalendar } from "react-icons/ci";
import { FcClearFilters } from "react-icons/fc";
import { GrEdit } from "react-icons/gr";
import { RiDeleteBin5Line } from "react-icons/ri";
import noRecordFound from "../assets/images/no-record.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import reportsIcon from "../assets/images/icons/reportsIcon.png";
import filterLinesIcon from "../assets/images/icons/FiltersLinesIcon.png";
import recordReadyIcon from "../assets/images/icons/ready.png";
import searchIcon from "../assets/images/icons/search.png";
import { IoFilterOutline } from "react-icons/io5";
import { formatDateForAPI } from '../utils/dateUtils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";


const Reports = () => {
  const [clickData, setClickData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [formData, setFormData] = useState({
    campaignName: "",
    accountId: "",
    fromDate: "",
    toDate: "",
  });
  const [urlHistory, setUrlHistory] = useState([]);
  const [urlTotalCount, setUrlTotalCount] = useState(0);
  const [urlHistoryLoading, setUrlHistoryLoading] = useState(false);
  const [urlHistorySearchTerm, setUrlHistorySearchTerm] = useState("");
  const [urlHistoryStartDate, setUrlHistoryStartDate] = useState(null);
  const [urlHistoryEndDate, setUrlHistoryEndDate] = useState(null);
  const [isUrlHistorySearching, setIsUrlHistorySearching] = useState(false);
  const [urlHistorySearchTimeout, setUrlHistorySearchTimeout] = useState(null);
  const [isUrlHistoryDownloading, setIsUrlHistoryDownloading] = useState(false);
  const [isUrlHistoryExporting, setIsUrlHistoryExporting] = useState(false);
  const [filter, setFilter] = useState({ column: "", value: "" });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [urlHistoryFilters, setUrlHistoryFilters] = useState({
    campaignName: "",
    senderId: "",
    indivId: "",
  });
  const [creditHistory, setCreditHistory] = useState([]);
  const [creditHistoryLoading, setCreditHistoryLoading] = useState(false);
  const [isCreditHistoryDownloading, setIsCreditHistoryDownloading] =
    useState(false);
  const [isCreditHistoryExporting, setIsCreditHistoryExporting] =
    useState(false);
  const [creditHistoryStartDate, setCreditHistoryStartDate] = useState(null);
  const [creditHistoryEndDate, setCreditHistoryEndDate] = useState(null);
  const [creditHistoryFilters, setCreditHistoryFilters] = useState({
    transactionType: "",
    creditType: "",
  });
  const [accounts, setAccounts] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [selectedAccountId, setSelectedAccountId] = useState("");
  const [activeTab, setActiveTab] = useState("clickData");
  const canAccessSftpConfiguration =
    userRole !== "CLIENT" && userRole !== "SUPERADMIN";
  const [sftpSubTab, setSftpSubTab] = useState("scheduleExport"); // scheduleExport, history, or scheduleHistory
  const [showScheduleHistoryTab, setShowScheduleHistoryTab] = useState(false); // Controls visibility of Schedule History tab
  const [userCreatedAt, setUserCreatedAt] = useState(null);
  const [accountCreatedAt, setAccountCreatedAt] = useState(null);
  const [creditConsumption, setCreditConsumption] = useState([]);
  const [creditLength,setCreditLength] = useState(0);
  const [creditConsumptionLoading, setCreditConsumptionLoading] =
    useState(false);
  const [isCreditConsumptionDownloading, setIsCreditConsumptionDownloading] =
    useState(false);
  const [isCreditConsumptionExporting, setIsCreditConsumptionExporting] =
    useState(false);
  const [creditConsumptionStartDate, setCreditConsumptionStartDate] =
    useState(null);
  const [creditConsumptionEndDate, setCreditConsumptionEndDate] =
    useState(null);
  const [creditConsumptionFilters, setCreditConsumptionFilters] = useState({
    transactionType: "DEBIT",
    creditType: "",
  });


  const [clickDataFilterOpen, setClickDataFilterOpen] = useState(false);
  const [urlHistoryFilterOpen, setUrlHistoryFilterOpen] = useState(false);
  const [creditHistoryFilterOpen, setCreditHistoryFilterOpen] = useState(false);
  const [creditConsumptionFilterOpen, setCreditConsumptionFilterOpen] = useState(false);


  const [clickDataAccountId, setClickDataAccountId] = useState("");
  const [urlHistoryAccountId, setUrlHistoryAccountId] = useState("");
  const [creditHistoryAccountId, setCreditHistoryAccountId] = useState("");
  const [creditConsumptionAccountId, setCreditConsumptionAccountId] = useState("");
  const [clickDataUnique, setClickDataUnique] = useState(false);
  const [clickDataCampaigns, setClickDataCampaigns] = useState([]);
  const [urlHistoryCampaigns, setUrlHistoryCampaigns] = useState([]);
  const [urlHistorySenderIds, setUrlHistorySenderIds] = useState([]);
  const [clickDataCampaignsLoading, setClickDataCampaignsLoading] = useState(false);
  const [urlHistoryCampaignsLoading, setUrlHistoryCampaignsLoading] = useState(false);

  // SFTP Destination form states
  const [sftpFormData, setSftpFormData] = useState({
    name: "",
    host: "",
    port: "",
    username: "",
    password: "",
    remoteDirectory: "",
    configType: "",
    schedule: "",
    time: "",
    scheduleDay: "",
    dayOfWeek: "",
    yearlyMonth: "",
    yearlyDay: "",
    configType: "",
  });
  const [executionType, setExecutionType] = useState("ONE_TIME"); // ONE_TIME or RECURRING
  const [selectedReportType, setSelectedReportType] = useState(""); // clickData, urlHistory, creditHistory, creditConsumption
  const [scheduleStartDate, setScheduleStartDate] = useState(null);
  const [scheduleTime, setScheduleTime] = useState("");
  const [scheduleFrequency, setScheduleFrequency] = useState(""); // DAILY, WEEKLY, MONTHLY
  const [scheduleDayOfWeek, setScheduleDayOfWeek] = useState("");
  const [scheduleDayOfMonth, setScheduleDayOfMonth] = useState("");
  const [scheduleDirectoryPath, setScheduleDirectoryPath] = useState(""); // Directory path for file storage
  // Dynamic filter states for each report type
  const [scheduleClickDataFilters, setScheduleClickDataFilters] = useState({
    campaignName: "",
    startDate: null,
    endDate: null,
  });
  const [scheduleUrlHistoryFilters, setScheduleUrlHistoryFilters] = useState({
    campaignName: "",
    senderId: "",
    indivId: "",
    startDate: null,
    endDate: null,
  });
  const [scheduleCreditHistoryFilters, setScheduleCreditHistoryFilters] = useState({
    transactionType: "",
    creditType: "",
    startDate: null,
    endDate: null,
  });
  const [scheduleCreditConsumptionFilters, setScheduleCreditConsumptionFilters] = useState({
    transactionType: "DEBIT",
    creditType: "",
    startDate: null,
    endDate: null,
  });
  const [sftpFormErrors, setSftpFormErrors] = useState({});
  const [sftpSubmitting, setSftpSubmitting] = useState(false);
  const [sftpTesting, setSftpTesting] = useState(false);
  const [sftpTestSuccess, setSftpTestSuccess] = useState(false);
  const [sftpConfigLoading, setSftpConfigLoading] = useState(false);
  const [sftpConfigId, setSftpConfigId] = useState(null);
  const [hasExistingConfig, setHasExistingConfig] = useState(false);
  const [allSftpConfigs, setAllSftpConfigs] = useState([]); // Store all SFTP configurations
  const [selectedConfigUsername, setSelectedConfigUsername] = useState(""); // Track selected config by username
  const [showScheduleFields, setShowScheduleFields] = useState(false);
  const [canTestConnection, setCanTestConnection] = useState(false);
  const [testConnectionFailed, setTestConnectionFailed] = useState(false);
  const [testConnectionError, setTestConnectionError] = useState("");
  const [schedules, setSchedules] = useState([]);
  const [schedulesLoading, setSchedulesLoading] = useState(false);
  const [showDeleteScheduleModal, setShowDeleteScheduleModal] = useState(false);
  const [scheduleToDelete, setScheduleToDelete] = useState(null);
  const [scheduleToEdit, setScheduleToEdit] = useState(null);
  const [isEditingSchedule, setIsEditingSchedule] = useState(false);
  const [executingScheduleId, setExecutingScheduleId] = useState(null);
  const [scheduleSearchTerm, setScheduleSearchTerm] = useState("");
  const [scheduleFrequencyFilter, setScheduleFrequencyFilter] = useState("ALL");
  const [scheduleSortField, setScheduleSortField] = useState(null);
  const [scheduleSortOrder, setScheduleSortOrder] = useState("asc");
  const [showHistoryTab, setShowHistoryTab] = useState(false);
  const [selectedScheduleForHistory, setSelectedScheduleForHistory] = useState(null);
  const [scheduleHistory, setScheduleHistory] = useState([]);
  const [scheduleHistoryLoading, setScheduleHistoryLoading] = useState(false);
  const [historyPage, setHistoryPage] = useState(0);
  const [historySize, setHistorySize] = useState(10);
  const [historyTotalPages, setHistoryTotalPages] = useState(0);
  const [historySearchTerm, setHistorySearchTerm] = useState("");
  const [historySortField, setHistorySortField] = useState(null);
  const [historySortOrder, setHistorySortOrder] = useState("asc");
  const [showSftpPassword, setShowSftpPassword] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const role = decoded.roles[0];
        setUserRole(role);
        if (role === "SUPERADMIN") {
          const accountId = decoded.accountId || decoded.companyId;
          setFormData((prev) => ({ ...prev, accountId }));
          setSelectedAccountId(accountId);
          fetchAccounts();
        } else {
          const accountId = decoded.accountId || decoded.companyId;
          setFormData((prev) => ({ ...prev, accountId }));
          setSelectedAccountId(accountId);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          const decoded = jwtDecode(token);
          const username = decoded.sub;

          const response = await userService.getUserByUsername(username);

          setUserCreatedAt(new Date(response.createdAt));
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        toast.error("Failed to fetch user details");
      }
    };

    fetchUserDetails();
  }, []);

  useEffect(() => {
    if (!canAccessSftpConfiguration && activeTab === "sftpDestination") {
      setActiveTab("clickData");
    }
  }, [activeTab, canAccessSftpConfiguration]);

  // Fetch SFTP configurations when SFTP tab is active
  useEffect(() => {
    const fetchSftpConfigurations = async () => {
      if (activeTab === "sftpDestination") {
        const accountId = userRole === "SUPERADMIN" ? selectedAccountId : formData.accountId;
        
        if (!accountId) {
          return;
        }

        setSftpConfigLoading(true);
        try {
          const response = await connectorService.getConfigurationsByType(accountId, 'export');
          
          // Check if response has data
          if (response && response.success && response.data && response.data.length > 0) {
            // Store all configurations
            setAllSftpConfigs(response.data);
            setHasExistingConfig(true);
            
            // Don't auto-populate - wait for user to select from dropdown
            // Only reset form if switching accounts or first load
            if (!selectedConfigUsername) {
              setSftpFormData({
                name: "",
                host: "",
                port: "",
                username: "",
                password: "",
                remoteDirectory: "",
                configType: "",
                schedule: "",
                time: "",
                scheduleDay: "",
                dayOfWeek: "",
                yearlyMonth: "",
                yearlyDay: "",
              });
              setSftpConfigId(null);
              setCanTestConnection(false);
              setShowScheduleFields(false);
            }
          } else {
            // No data found - keep form empty
            setAllSftpConfigs([]);
            setSftpFormData({
              name: "",
              configType: "",
              host: "",
              port: "",
              username: "",
              password: "",
              remoteDirectory: "",
              configType: "",
              schedule: "",
              time: "",
              scheduleDay: "",
              dayOfWeek: "",
              yearlyMonth: "",
              yearlyDay: "",
            });
            setSftpConfigId(null);
            setHasExistingConfig(false);
            setShowScheduleFields(false);
            setCanTestConnection(false);
            setSelectedConfigUsername("");
          }
        } catch (error) {
          console.error("Error fetching SFTP configurations:", error);
          if (error.response?.status !== 404) {
            toast.error("Failed to load SFTP configuration");
          }
          // Keep form empty on error
          setAllSftpConfigs([]);
          setSftpFormData({
            name: "",
            configType: "",
            host: "",
            port: "",
            username: "",
            password: "",
            remoteDirectory: "",
            configType: "",
            schedule: "",
            time: "",
            scheduleDay: "",
            dayOfWeek: "",
            yearlyMonth: "",
            yearlyDay: "",
          });
          setSftpConfigId(null);
          setHasExistingConfig(false);
          setShowScheduleFields(false);
          setCanTestConnection(false);
          setSelectedConfigUsername("");
        } finally {
          setSftpConfigLoading(false);
        }
      }
    };

    fetchSftpConfigurations();
  }, [activeTab, userRole, selectedAccountId, formData.accountId]);

  // Fetch schedules when SFTP tab is active
  useEffect(() => {
    const fetchSchedules = async () => {
      if (activeTab === "sftpDestination") {
        console.log("Fetching schedules...", activeTab, userRole, selectedAccountId, formData.accountId);
        const accountId = userRole === "SUPERADMIN" ? selectedAccountId : formData.accountId;
        
        if (!accountId) {
          return;
        }

        setSchedulesLoading(true);
        try {
          const response = await connectorService.getAllSchedules(accountId);
          
          if (response && response.success && response.data) {
            setSchedules(response.data);
          } else {
            setSchedules([]);
          }
        } catch (error) {
          console.error("Error fetching schedules:", error);
          // if (error.response?.status !== 404) {
          //   toast.error("Failed to load schedules");
          // }
          setSchedules([]);
        } finally {
          setSchedulesLoading(false);
        }
      }
    };

    fetchSchedules();
  }, [activeTab, userRole, selectedAccountId, formData.accountId]);

  const fetchAccounts = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await accountService.getAccountConfigs();
      setAccounts(response);
    } catch (error) {
      console.error("Error fetching accounts:", error);
      toast.error("Failed to fetch accounts");
    }
  };

  const fetchCampaignsByAccountId = async (accountId, tab) => {
    try {
      if (tab === 'clickData') {
        setClickDataCampaignsLoading(true);
      } else if (tab === 'urlHistory') {
        setUrlHistoryCampaignsLoading(true);
      }

      const response = await accountService.getCampaignsByAccountId(accountId);
      if (tab === 'clickData') {
        setClickDataCampaigns(response || []);
      } else if (tab === 'urlHistory') {
        setUrlHistoryCampaigns(response || []);
      }
    } catch (error) {
      console.error(`Error fetching campaigns for ${tab}:`, error);
      toast.error("Failed to fetch campaigns");
      if (tab === 'clickData') {
        setClickDataCampaigns([]);
      } else if (tab === 'urlHistory') {
        setUrlHistoryCampaigns([]);
      }
    } finally {
      if (tab === 'clickData') {
        setClickDataCampaignsLoading(false);
      } else if (tab === 'urlHistory') {
        setUrlHistoryCampaignsLoading(false);
      }
    }
  };

  const fetchAccountDataForUrlHistory = async (accountId) => {
    try {
      setUrlHistoryCampaignsLoading(true);
      const response = await accountService.getAccountDataByAccountId(accountId);
      setUrlHistoryCampaigns(response?.campaigns || []);
      setUrlHistorySenderIds(response?.senderIds || []);
    } catch (error) {
      console.error('Error fetching account data for URL History:', error);
      toast.error("Failed to fetch account data");
      setUrlHistoryCampaigns([]);
      setUrlHistorySenderIds([]);
    } finally {
      setUrlHistoryCampaignsLoading(false);
    }
  };

  const fetchAccountCreatedDate = async (accountId) => {
    try {
      const response = await accountService.getAccountConfigById(accountId);
      if (response?.createdAt) {
        setAccountCreatedAt(new Date(response.createdAt));
      } else {
        setAccountCreatedAt(null);
      }
    } catch (error) {
      console.error('Error fetching account created date:', error);
      setAccountCreatedAt(null);
    }
  };

  const fetchClickData = async (e) => {
    e?.preventDefault();
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const clickDataAccountIdToUse =
        userRole === "SUPERADMIN"
          ? clickDataAccountId || selectedAccountId
          : formData.accountId;

      const filterData = {
        ...formData,
        accountId: clickDataAccountIdToUse,
        campaignName: filter.value,
        fromDate: formatDateForAPI(startDate),
        toDate: formatDateForAPI(endDate),
        unique: clickDataUnique,
      };

      const response = await reportsService.getClickData(filterData);
      setClickData(response);
      toast.success("Data fetched successfully");
    } catch (error) {
      console.error("Error fetching click data:", error);
      toast.error("Failed to fetch click data");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDownloadCSV = async () => {
    try {
      setDownloading(true);
      const token = localStorage.getItem("token");
      const clickDataAccountIdToUse =
        userRole === "SUPERADMIN"
          ? clickDataAccountId || selectedAccountId
          : formData.accountId;

      console.log("Downloading with params:", selectedAccountId, formData, filter, startDate, endDate);
      const response = await reportsService.exportClickData({
        accountId: clickDataAccountIdToUse,
        campaignName: filter.value || "",
        fromDate: formatDateForAPI(startDate),
        toDate: formatDateForAPI(endDate),
        unique: clickDataUnique,
      });

      let csvContent = "";

      if (typeof response === "string") {
        csvContent = response;
      } else if (response instanceof Blob) {
        csvContent = await response.text();
      } else if (response instanceof ArrayBuffer) {
        csvContent = new TextDecoder("utf-8").decode(response);
      }

      if (csvContent.trim()) {
        const lineBreak = csvContent.includes("\r\n") ? "\r\n" : "\n";
        const rows = csvContent.split(/\r?\n/);
        const hasDataRows = rows.length > 1 && rows[1].trim() !== "";

        if (hasDataRows && rows[0]) {
          rows[0] = rows[0].replace(/\bcreatedAt\b/g, "clickedAt");
          csvContent = rows.join(lineBreak);
        }
      }

      const blob = new Blob([csvContent || response], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `click-data-${new Date().toISOString()}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Click Data report downloaded successfully!");
    } catch (error) {
      console.error("Error downloading click data:", error);
      toast.error("Failed to download click data");
    } finally {
      setDownloading(false);
    }
  };

  const handleExportCSV = async () => {
    try {
      setExporting(true);
      const token = localStorage.getItem("token");
      const clickDataAccountIdToUse =
        userRole === "SUPERADMIN"
          ? clickDataAccountId || selectedAccountId
          : formData.accountId;

      const response = await reportsService.exportClickData({
        accountId: clickDataAccountIdToUse,
        campaignName: filter.value || "",
        fromDate: formatDateForAPI(startDate),
        toDate: formatDateForAPI(endDate),
        unique: clickDataUnique,
      });

      const blob = new Blob([response], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `click-data-export-${new Date().toISOString()}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Click Data report exported successfully!");
    } catch (error) {
      console.error("Error exporting click data:", error);
      toast.error("Failed to export click data");
    } finally {
      setExporting(false);
    }
  };

  const handleUrlHistoryDateChange = (date, isStartDate) => {
    if (isStartDate) {
      setUrlHistoryStartDate(date);
      if (urlHistoryEndDate && date > urlHistoryEndDate) {
        setUrlHistoryEndDate(date);
      }
    } else {
      setUrlHistoryEndDate(date);
      if (urlHistoryStartDate && date < urlHistoryStartDate) {
        setUrlHistoryStartDate(date);
      }
    }
  };

  const handleUrlHistorySearch = async () => {
    setIsUrlHistorySearching(true);
    try {
      const token = localStorage.getItem("token");
      
      // Build payload for the POST API endpoint
      const requestPayload = {
        accountId: userRole === "SUPERADMIN" ? urlHistoryAccountId : formData.accountId,
        campaignName: urlHistoryFilters.campaignName || "",
        senderId: urlHistoryFilters.senderId || "",
        individualId: urlHistoryFilters.indivId || "",
        fromDate: formatDateForAPI(urlHistoryStartDate),
        toDate: formatDateForAPI(urlHistoryEndDate)
      };


      const response = await urlService.searchUrlMappings(requestPayload);
      setUrlTotalCount(response.totalRecords || response.data?.totalRecords || 0);
      console.log("response", response);
      setUrlHistory(response.content || response.data?.content || []);
    } catch (error) {
      console.error("Error searching URL history:", error);
      toast.error("Failed to search URL history");
    } finally {
      setIsUrlHistorySearching(false);
    }
  };

  const handleUrlHistoryFilterChange = (field, value) => {
    setUrlHistoryFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const clearUrlHistoryFilters = () => {
    setUrlHistoryFilters({
      campaignName: "",
      senderId: "",
      indivId: "",
    });
    setUrlHistoryStartDate(null);
    setUrlHistoryEndDate(null);
    setUrlHistory([]);
    setUrlTotalCount(0);
    setIsUrlHistoryDownloading(false);
    setIsUrlHistoryExporting(false);
  };

  const debouncedUrlHistorySearch = (value) => {
    setUrlHistorySearchTerm(value);

    if (urlHistorySearchTimeout) {
      clearTimeout(urlHistorySearchTimeout);
    }

    const timeoutId = setTimeout(() => {
      handleUrlHistorySearch();
    }, 500);

    setUrlHistorySearchTimeout(timeoutId);
  };

  const handleUrlHistoryDownload = async () => {
    try {
      setIsUrlHistoryDownloading(true);
      const token = localStorage.getItem("token");

      // Build payload for the POST API endpoint
      const requestPayload = {
        accountId: userRole === "SUPERADMIN" ? urlHistoryAccountId : formData.accountId,
        campaignName: urlHistoryFilters.campaignName || "",
        senderId: urlHistoryFilters.senderId || "",
        individualId: urlHistoryFilters.indivId || "",
        fromDate: formatDateForAPI(urlHistoryStartDate),
        toDate: formatDateForAPI(urlHistoryEndDate)
      };


      const response = await urlService.exportUrlMappings(requestPayload);

      const blob = new Blob([response], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `url-history-${new Date().toISOString()}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("URL History report downloaded successfully!");
    } catch (error) {
      console.error("Error downloading URL history:", error);
      toast.error("Failed to download URL history");
    } finally {
      setIsUrlHistoryDownloading(false);
    }
  };

  const handleUrlHistoryExport = async () => {
    try {
      setIsUrlHistoryExporting(true);
      const token = localStorage.getItem("token");

      // Build payload for the POST API endpoint
      const requestPayload = {
        accountId: userRole === "SUPERADMIN" ? urlHistoryAccountId : formData.accountId,
        campaignName: urlHistoryFilters.campaignName || "",
        senderId: urlHistoryFilters.senderId || "",
        individualId: urlHistoryFilters.indivId || "",
        fromDate: formatDateForAPI(urlHistoryStartDate),
        toDate: formatDateForAPI(urlHistoryEndDate)
      };

      const response = await urlService.exportUrlMappings(requestPayload);

      const blob = new Blob([response], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `url-history-export-${new Date().toISOString()}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("URL History report exported successfully!");
    } catch (error) {
      console.error("Error exporting URL history:", error);
      toast.error("Failed to export URL history");
    } finally {
      setIsUrlHistoryExporting(false);
    }
  };

  // Navigate to SFTP Schedule Export with pre-populated data
  const navigateToScheduleExport = (reportType, filters = {}) => {
    if (!canAccessSftpConfiguration) {
      return;
    }

    // Navigate to SFTP Configuration tab and Schedule Export sub-tab
    setActiveTab("sftpDestination");
    setSftpSubTab("scheduleExport");
    
    // Set execution type to ONCE (One Time)
    setExecutionType("ONE_TIME");
    setScheduleFrequency("ONCE");
    
    // Set report type
    setSelectedReportType(reportType);
    
    // Pre-populate filters based on report type
    if (reportType === "clickData") {
      setScheduleClickDataFilters({
        campaignName: filters.campaignName || filter.value || "",
        startDate: filters.startDate || startDate,
        endDate: filters.endDate || endDate,
      });
    } else if (reportType === "urlHistory") {
      setScheduleUrlHistoryFilters({
        campaignName: filters.campaignName || urlHistoryFilters.campaignName || "",
        senderId: filters.senderId || urlHistoryFilters.senderId || "",
        indivId: filters.indivId || urlHistoryFilters.indivId || "",
        startDate: filters.startDate || urlHistoryStartDate,
        endDate: filters.endDate || urlHistoryEndDate,
      });
    } else if (reportType === "creditHistory") {
      setScheduleCreditHistoryFilters({
        transactionType: filters.transactionType || creditHistoryFilters.transactionType || "",
        creditType: filters.creditType || creditHistoryFilters.creditType || "",
        startDate: filters.startDate || creditHistoryStartDate,
        endDate: filters.endDate || creditHistoryEndDate,
      });
    } else if (reportType === "creditConsumption") {
      setScheduleCreditConsumptionFilters({
        transactionType: filters.transactionType || creditConsumptionFilters.transactionType || "DEBIT",
        creditType: filters.creditType || creditConsumptionFilters.creditType || "",
        startDate: filters.startDate || creditConsumptionStartDate,
        endDate: filters.endDate || creditConsumptionEndDate,
      });
    }
    
    // Show schedule fields if config is available
    if (hasExistingConfig && selectedConfigUsername) {
      setShowScheduleFields(true);
    }
    
    toast.info("Configure your export schedule below");
  };

  const handleFilterChange = (field, value) => {
    setFilter((prev) => ({ ...prev, [field]: value }));
  };

  const handleDateChange = (date, isStartDate) => {
    if (isStartDate) {
      setStartDate(date);
      if (endDate && date > endDate) {
        setEndDate(date);
      }
    } else {
      setEndDate(date);
      if (startDate && date < startDate) {
        setStartDate(date);
      }
    }
  };

  const handleCreditHistoryDateChange = (date, isStartDate) => {
    if (isStartDate) {
      setCreditHistoryStartDate(date);
      if (creditHistoryEndDate && date > creditHistoryEndDate) {
        setCreditHistoryEndDate(date);
      }
    } else {
      setCreditHistoryEndDate(date);
      if (creditHistoryStartDate && date < creditHistoryStartDate) {
        setCreditHistoryStartDate(date);
      }
    }
  };

  const handleCreditHistoryFilterChange = (field, value) => {
    setCreditHistoryFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCreditHistorySearch = async () => {
    setCreditHistoryLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await creditService.searchCreditHistory({
        accountId: userRole === "SUPERADMIN" ? creditHistoryAccountId : formData.accountId,
        transactionType: creditHistoryFilters.transactionType || "",
        exceptConsumption: true,
        creditType: creditHistoryFilters.creditType || "",
        fromDate: formatDateForAPI(creditHistoryStartDate),
        toDate: formatDateForAPI(creditHistoryEndDate),
      });
      setCreditHistory(response.content || []);
    } catch (error) {
      console.error("Error searching credit history:", error);
      toast.error("Failed to search credit history");
    } finally {
      setCreditHistoryLoading(false);
    }
  };

  const handleCreditHistoryDownload = async () => {
    try {
      setIsCreditHistoryDownloading(true);
      const token = localStorage.getItem("token");

      const response = await creditService.exportCreditHistory({
        accountId: userRole === "SUPERADMIN" ? creditHistoryAccountId : formData.accountId,
        transactionType: creditHistoryFilters.transactionType || "",
        exceptConsumption: true,
        creditType: creditHistoryFilters.creditType || "",
        fromDate: formatDateForAPI(creditHistoryStartDate),
        toDate: formatDateForAPI(creditHistoryEndDate),
      });

      const blob = new Blob([response], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `credit-history-${new Date().toISOString()}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Credit History report downloaded successfully!");
    } catch (error) {
      console.error("Error downloading credit history:", error);
      toast.error("Failed to download credit history");
    } finally {
      setIsCreditHistoryDownloading(false);
    }
  };

  const handleCreditHistoryExport = async () => {
    try {
      setIsCreditHistoryExporting(true);
      const token = localStorage.getItem("token");

      const response = await creditService.exportCreditHistory({
        accountId: userRole === "SUPERADMIN" ? creditHistoryAccountId : formData.accountId,
        transactionType: creditHistoryFilters.transactionType || "",
        exceptConsumption: true,
        creditType: creditHistoryFilters.creditType || "",
        fromDate: formatDateForAPI(creditHistoryStartDate),
        toDate: formatDateForAPI(creditHistoryEndDate),
      });

      const blob = new Blob([response], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `credit-history-export-${new Date().toISOString()}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Credit History report exported successfully!");
    } catch (error) {
      console.error("Error exporting credit history:", error);
      toast.error("Failed to export credit history");
    } finally {
      setIsCreditHistoryExporting(false);
    }
  };

  const handleAccountChange = (accountId) => {
    // Fetch account created date for SUPERADMIN when account is selected
    if (userRole === "SUPERADMIN" && accountId) {
      fetchAccountCreatedDate(accountId);
    } else {
      setAccountCreatedAt(null);
    }

    switch(activeTab) {
      case 'clickData':
        setClickDataAccountId(accountId);
        setFormData((prev) => ({ ...prev, accountId }));
        setClickData([]);
        if (accountId) {
          fetchCampaignsByAccountId(accountId, 'clickData');
        } else {
          setClickDataCampaigns([]);
        }
        break;
      case 'urlHistory':
        setUrlHistoryAccountId(accountId);
        setUrlHistory([]);
        if (accountId) {
          fetchAccountDataForUrlHistory(accountId);
        } else {
          setUrlHistoryCampaigns([]);
          setUrlHistorySenderIds([]);
        }
        break;
      case 'creditHistory':
        setCreditHistoryAccountId(accountId);
        setCreditHistory([]);
        break;
      case 'creditConsumption':
        setCreditConsumptionAccountId(accountId);
        setCreditConsumption([]);
        break;
      default :
      break;

    }
  };

  const handleCreditConsumptionDateChange = (date, isStartDate) => {
    if (isStartDate) {
      setCreditConsumptionStartDate(date);
      if (creditConsumptionEndDate && date > creditConsumptionEndDate) {
        setCreditConsumptionEndDate(date);
      }
    } else {
      setCreditConsumptionEndDate(date);
      if (creditConsumptionStartDate && date < creditConsumptionStartDate) {
        setCreditConsumptionStartDate(date);
      }
    }
  };

  const handleCreditConsumptionFilterChange = (field, value) => {
    setCreditConsumptionFilters((prev) => ({
      ...prev,
      [field]: value,
      transactionType: "DEBIT",
    }));
  };

  const handleCreditConsumptionSearch = async () => {
    setCreditConsumptionLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await creditService.searchCreditHistory({
        accountId: userRole === "SUPERADMIN" ? creditConsumptionAccountId : formData.accountId,
        transactionType: creditConsumptionFilters.transactionType || "",
        exceptConsumption: false,
        creditType: creditConsumptionFilters.creditType || "",
        fromDate: formatDateForAPI(creditConsumptionStartDate),
        toDate: formatDateForAPI(creditConsumptionEndDate),
      });

      console.log("response", response);
      setCreditConsumption(response.content || []);
      setCreditLength(response.totalRecords || 0);
    } catch (error) {
      console.error("Error searching credit consumption:", error);
      toast.error("Failed to search credit consumption");
    } finally {
      setCreditConsumptionLoading(false);
    }
  };

  const handleCreditConsumptionDownload = async () => {
    try {
      setIsCreditConsumptionDownloading(true);
      const token = localStorage.getItem("token");

      const response = await creditService.exportCreditHistory({
        accountId: userRole === "SUPERADMIN" ? creditConsumptionAccountId : formData.accountId,
        transactionType: creditConsumptionFilters.transactionType || "",
        exceptConsumption: false,
        creditType: creditConsumptionFilters.creditType || "",
        fromDate: formatDateForAPI(creditConsumptionStartDate),
        toDate: formatDateForAPI(creditConsumptionEndDate),
      });

      const blob = new Blob([response], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `credit-consumption-${new Date().toISOString()}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Credit Consumption report downloaded successfully!");
    } catch (error) {
      console.error("Error downloading credit consumption:", error);
      toast.error("Failed to download credit consumption");
    } finally {
      setIsCreditConsumptionDownloading(false);
    }
  };

  const handleCreditConsumptionExport = async () => {
    try {
      setIsCreditConsumptionExporting(true);
      const token = localStorage.getItem("token");

      const response = await creditService.exportCreditHistory({
        accountId: userRole === "SUPERADMIN" ? creditConsumptionAccountId : formData.accountId,
        transactionType: creditConsumptionFilters.transactionType || "",
        exceptConsumption: false,
        creditType: creditConsumptionFilters.creditType || "",
        fromDate: formatDateForAPI(creditConsumptionStartDate),
        toDate: formatDateForAPI(creditConsumptionEndDate),
      });

      const blob = new Blob([response], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `credit-consumption-export-${new Date().toISOString()}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Credit Consumption report exported successfully!");
    } catch (error) {
      console.error("Error exporting credit consumption:", error);
      toast.error("Failed to export credit consumption");
    } finally {
      setIsCreditConsumptionExporting(false);
    }
  };

  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);



  <div className="mb-4">
    <div className="d-flex align-items-center gap-2">
      <Dropdown
        show={isFilterDropdownOpen}
        onToggle={(isOpen) => setIsFilterDropdownOpen(isOpen)}
      >
        <Dropdown.Toggle
          variant="white"
          className="d-flex  align-items-center gap-2 br-radius-8"
          style={{
            border: `1px solid ${isFilterDropdownOpen ? "#28a745" : "#EAECEE"}`,
          }}
        >
          <Image src={filterLinesIcon} width={12} /> 
          <span className="fw-400 fs-12">Filter</span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="p-3 mt-2" style={{ width: "400px" }}>
         
        </Dropdown.Menu>
      </Dropdown>

      {((userRole === "SUPERADMIN" && clickDataAccountId) || 
        (filter.column && filter.value) || 
        startDate || 
        endDate) && (
        <Button
          variant="light"
          size="sm"
          className="d-flex align-items-center gap-2 br-radius-8"
          style={{
            border: "1px solid #EAECEE",
            padding: "9px 15px",
          }}
          onClick={() => {
            setFilter({ column: "", value: "" });
            setStartDate(null);
            setEndDate(null);
            setDownloading(false);
            setExporting(false);
            if (userRole === "SUPERADMIN") {
              setClickDataAccountId("");
              setFormData((prev) => ({ ...prev, accountId: "" }));
            }
            setClickData([]);
          }}
        >
          <FcClearFilters size={12} />
          <span className="fw-400 fs-12">Clear All</span>
        </Button>
      )}
    </div>
  </div>

  // SFTP Destination form handlers
  const handleSftpInputChange = (e) => {
    const { name, value, type } = e.target;
    
    setSftpFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    
    // Clear frequency-specific fields when changing schedule type
    if (name === "schedule") {
      setSftpFormData((prev) => ({
        ...prev,
        [name]: value,
        scheduleDay: "",
        dayOfWeek: "",
        yearlyMonth: "",
        yearlyDay: "",
      }));
    }
    
    // Clear error for this field
    if (sftpFormErrors[name]) {
      setSftpFormErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
    
    // Handle test connection availability based on field changes
    if (hasExistingConfig && ['host', 'port', 'username', 'remoteDirectory', 'configType'].includes(name)) {
      // If non-password config fields change, disable test connection
      setCanTestConnection(false);
      setSftpTestSuccess(false);
      setShowScheduleFields(false);
      setTestConnectionFailed(false);
      setTestConnectionError("");
    } else if (hasExistingConfig && name === 'password') {
      // If password is entered on existing config, enable test connection
      if (value.trim()) {
        setCanTestConnection(true);
        setTestConnectionFailed(false);
        setTestConnectionError("");
      } else {
        setCanTestConnection(false);
      }
      setSftpTestSuccess(false);
      setShowScheduleFields(false);
    }
  };

  const isSftpBasicFormValid = () => {
    if (!sftpFormData.configType) return false;
    if (!sftpFormData.host.trim()) return false;
    if (!sftpFormData.port.trim()) return false;
    if (isNaN(sftpFormData.port) || parseInt(sftpFormData.port) < 1 || parseInt(sftpFormData.port) > 65535) return false;
    if (!sftpFormData.username.trim()) return false;
    if (!sftpFormData.password.trim()) return false;
    if (!sftpFormData.remoteDirectory.trim()) return false;
    return true;
  };

  const isSftpScheduleFormValid = () => {
    console.log("=== Schedule Form Validation ===");
    console.log("executionType:", executionType);
    console.log("selectedReportType:", selectedReportType);
    console.log("scheduleStartDate:", scheduleStartDate);
    console.log("scheduleTime:", scheduleTime);
    console.log("scheduleFrequency:", scheduleFrequency);
    console.log("scheduleDayOfWeek:", scheduleDayOfWeek);
    console.log("scheduleDayOfMonth:", scheduleDayOfMonth);
    
    // Check execution type and basic fields
    if (!executionType) {
      console.log("❌ Validation failed: executionType not set");
      return false;
    }
    if (!selectedReportType) {
      console.log("❌ Validation failed: selectedReportType not set");
      return false;
    }
    
    // One Time Execution validation
    if (executionType === "ONE_TIME") {
      if (!scheduleStartDate) {
        console.log("❌ Validation failed: scheduleStartDate not set (ONE_TIME)");
        return false;
      }
      if (!scheduleTime.trim()) {
        console.log("❌ Validation failed: scheduleTime not set (ONE_TIME)");
        return false;
      }
      console.log("✅ Validation passed: ONE_TIME execution");
      return true; 
    }
    
    // Recurring Schedule validation
    if (executionType === "RECURRING") {
      if (!scheduleFrequency) {
        console.log("❌ Validation failed: scheduleFrequency not set");
        return false;
      }
      if (!scheduleTime.trim()) {
        console.log("❌ Validation failed: scheduleTime not set (RECURRING)");
        return false;
      }
      if (!scheduleStartDate) {
        console.log("❌ Validation failed: scheduleStartDate not set (RECURRING)");
        return false;
      }
      
      // Weekly requires day of week
      if (scheduleFrequency === "WEEKLY" && !scheduleDayOfWeek) {
        console.log("❌ Validation failed: scheduleDayOfWeek not set (WEEKLY)");
        return false;
      }
      
      // Monthly requires day of month
      if (scheduleFrequency === "MONTHLY" && !scheduleDayOfMonth) {
        console.log("❌ Validation failed: scheduleDayOfMonth not set (MONTHLY)");
        return false;
      }
      
      // Yearly requires start date for month and day
      if (scheduleFrequency === "YEARLY" && !scheduleStartDate) {
        console.log("❌ Validation failed: scheduleStartDate not set (YEARLY)");
        return false;
      }
      
      console.log("✅ Validation passed: RECURRING schedule");
      return true;
    }
    
    console.log("❌ Validation failed: Unknown execution type");
    return false;
  };

  const validateSftpBasicForm = () => {
    const errors = {};
    
    if (!sftpFormData.configType) {
      errors.configType = "Configuration type is required";
    }
    if (!sftpFormData.host.trim()) {
      errors.host = "Host is required";
    }
    if (!sftpFormData.port.trim()) {
      errors.port = "Port is required";
    } else if (isNaN(sftpFormData.port) || parseInt(sftpFormData.port) < 1 || parseInt(sftpFormData.port) > 65535) {
      errors.port = "Port must be a valid number between 1 and 65535";
    }
    if (!sftpFormData.username.trim()) {
      errors.username = "Username is required";
    }
    if (!sftpFormData.password.trim()) {
      errors.password = "Password is required";
    }
    if (!sftpFormData.remoteDirectory.trim()) {
      errors.remoteDirectory = "Remote directory is required";
    }
    if (!sftpFormData.configType) {
      errors.configType = "Config type is required";
    }
    
    setSftpFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateSftpScheduleForm = () => {
    console.log("=== validateSftpScheduleForm called ===");
    const errors = {};
    
    if (!executionType) {
      errors.executionType = "Execution type is required";
      console.log("Error: executionType missing");
    }
    if (!selectedReportType) {
      errors.reportType = "Report type is required";
      console.log("Error: selectedReportType missing");
    }
    if (!scheduleTime.trim()) {
      errors.time = "Time is required";
      console.log("Error: scheduleTime missing");
    }
    if (!scheduleStartDate) {
      errors.startDate = "Start date is required";
      console.log("Error: scheduleStartDate missing");
    }
    
    if (executionType === "RECURRING") {
      if (!scheduleFrequency) {
        errors.frequency = "Frequency is required for recurring schedules";
        console.log("Error: scheduleFrequency missing");
      }
      if (scheduleFrequency === "MONTHLY" && !scheduleDayOfMonth) {
        errors.dayOfMonth = "Day of month is required for monthly schedule";
        console.log("Error: scheduleDayOfMonth missing");
      }
      if (scheduleFrequency === "WEEKLY" && !scheduleDayOfWeek) {
        errors.dayOfWeek = "Day of week is required for weekly schedule";
        console.log("Error: scheduleDayOfWeek missing");
      }
      if (scheduleFrequency === "YEARLY" && !scheduleStartDate) {
        errors.yearlyDate = "Start date is required for yearly schedule";
        console.log("Error: scheduleStartDate missing for YEARLY");
      }
    }
    
    console.log("Validation errors:", errors);
    setSftpFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleConfigurationSelect = (username) => {
    setSelectedConfigUsername(username);
    
    // Find the selected configuration
    const selectedConfig = allSftpConfigs.find(config => config.username === username);
    
    if (selectedConfig) {
      // Populate form fields with selected configuration
      setSftpFormData({
        name: selectedConfig.name || "",
        host: selectedConfig.host || "",
        port: selectedConfig.port ? selectedConfig.port.toString() : "",
        username: selectedConfig.username || "",
        password: "",
        remoteDirectory: selectedConfig.remotePath || "",
        configType: selectedConfig.configType || selectedConfig.type || "",
        schedule: "",
        time: "",
        scheduleDay: "",
        dayOfWeek: "",
        yearlyMonth: "",
        yearlyDay: "",
      });
      
      setSftpConfigId(selectedConfig.id);
      setCanTestConnection(true);
      setSftpTestSuccess(false);
      setShowScheduleFields(false);
      setTestConnectionFailed(false);
      setTestConnectionError("");
      setSftpFormErrors({});
    }
  };

  const handleSftpSaveConfiguration = async () => {
    if (!validateSftpBasicForm()) {
      toast.error("Please fill all required fields correctly");
      return;
    }

    setSftpSubmitting(true);
    try {
      const accountId = userRole === "SUPERADMIN" ? selectedAccountId : formData.accountId;
      
      const configData = {
        name: sftpFormData.name,
        host: sftpFormData.host,
        port: parseInt(sftpFormData.port),
        username: sftpFormData.username,
        password: sftpFormData.password,
        remotePath: sftpFormData.remoteDirectory,
        configType: sftpFormData.configType,
      };

      await connectorService.createConfiguration(accountId, configData);
      toast.success("SFTP configuration saved successfully!");
      
      // Fetch the saved configuration
      const response = await connectorService.getAllConfigurations(accountId);
      if (response && response.success && response.data && response.data.length > 0) {
        const config = response.data[0];
        setSftpConfigId(config.id);
        setHasExistingConfig(true);
        setCanTestConnection(true); // Enable test connection after saving
        setTestConnectionFailed(false); // Clear any previous test failures
        setTestConnectionError("");
        
        // Update form with saved data
        setSftpFormData(prev => ({
          ...prev,
          name: config.name || prev.name,
          configType: config.configType || prev.configType,
          host: config.host || prev.host,
          port: config.port ? config.port.toString() : prev.port,
          username: config.username || prev.username,
          remoteDirectory: config.remotePath || prev.remoteDirectory,
        }));
      }
    } catch (error) {
      console.error("Error saving SFTP configuration:", error);
      toast.error(error.response?.data?.message || "Failed to save SFTP configuration");
    } finally {
      setSftpSubmitting(false);
    }
  };

  const handleSftpUpdateConfiguration = async () => {
    if (!validateSftpBasicForm()) {
      toast.error("Please fill all required fields correctly");
      return;
    }

    if (!sftpConfigId) {
      toast.error("No configuration found to update");
      return;
    }

    setSftpSubmitting(true);
    try {
      const accountId = userRole === "SUPERADMIN" ? selectedAccountId : formData.accountId;
      
      const configData = {
        name: sftpFormData.name,
        configType: sftpFormData.configType,
        host: sftpFormData.host,
        port: parseInt(sftpFormData.port),
        username: sftpFormData.username,
        password: sftpFormData.password,
        remotePath: sftpFormData.remoteDirectory,
        configType: sftpFormData.configType,
      };

      await connectorService.updateConfiguration(accountId, sftpConfigId, configData);
      toast.success("SFTP configuration updated successfully!");
      
      // Fetch the updated configuration
      const response = await connectorService.getAllConfigurations(accountId);
      if (response && response.success && response.data && response.data.length > 0) {
        const config = response.data[0];
        
        // Update form with saved data
        setSftpFormData(prev => ({
          ...prev,
          name: config.name || prev.name,
          configType: config.configType || prev.configType,
          host: config.host || prev.host,
          port: config.port ? config.port.toString() : prev.port,
          username: config.username || prev.username,
          remoteDirectory: config.remotePath || prev.remoteDirectory,
        }));
        
        setCanTestConnection(true); // Enable test connection after updating
        setTestConnectionFailed(false); // Clear any previous test failures
        setTestConnectionError("");
      }
    } catch (error) {
      console.error("Error updating SFTP configuration:", error);
      toast.error(error.response?.data?.message || "Failed to update SFTP configuration");
    } finally {
      setSftpSubmitting(false);
    }
  };

  const handleSftpTestConnection = async () => {
    if (!sftpConfigId) {
      toast.error("Please save the configuration first");
      return;
    }

    if (!sftpConfigId && !sftpFormData.password.trim()) {
      toast.error("Please enter password to test connection");
      return;
    }

    setSftpTesting(true);
    setSftpTestSuccess(false);
    setTestConnectionFailed(false);
    setTestConnectionError("");
    
    try {
      const accountId = userRole === "SUPERADMIN" ? selectedAccountId : formData.accountId;
      
      // First update configuration with current form data (especially password)
      const configData = {
        host: sftpFormData.host,
        port: parseInt(sftpFormData.port),
        username: sftpFormData.username,
        password: sftpFormData.password,
        remotePath: sftpFormData.remoteDirectory,
        configType: sftpFormData.configType,
      };
      console.log("Updating configuration before test:", configData);
      
      // await connectorService.updateConfiguration(accountId, sftpConfigId, configData);
      
      // Then test the connection
      const response = await connectorService.testConnection(accountId, sftpConfigId);
      
      // Check if response has success: true
      if (response && response.success === true) {
        setSftpTestSuccess(true);
        setShowScheduleFields(true);
        setTestConnectionFailed(false);
        setTestConnectionError("");
        toast.success(response.message || "Connection test successful! You can now schedule the export.");
      } else {
        setSftpTestSuccess(false);
        setShowScheduleFields(false);
        setTestConnectionFailed(true);
        setTestConnectionError(response?.message || "Connection test failed. Please check your credentials.");
        toast.error(response?.message || "Connection test failed. Please check your credentials.");
      }
    } catch (error) {
      console.error("Error testing SFTP connection:", error);
      const errorMessage = error.response?.data?.message || "Connection test failed. Please check your credentials.";
      toast.error(errorMessage);
      setSftpTestSuccess(false);
      setShowScheduleFields(false);
      setTestConnectionFailed(true);
      setTestConnectionError(errorMessage);
    } finally {
      setSftpTesting(false);
    }
  };

  const handleSftpFinish = async () => {
    if (!validateSftpScheduleForm()) {
      toast.error("Please fill all schedule fields correctly");
      return;
    }

    if (!sftpConfigId) {
      toast.error("No configuration found");
      return;
    }

    setSftpSubmitting(true);
    try {
      const accountId = userRole === "SUPERADMIN" ? selectedAccountId : formData.accountId;
      
      // Map report type to API format
      const reportTypeMap = {
        "clickData": "CLICK_DATA",
        "urlHistory": "URL_SHORTENING",
        "creditHistory": "CREDIT_HISTORY",
        "creditConsumption": "CREDIT_CONSUMPTION"
      };
      
      // Build schedule data according to API spec
      const scheduleData = {
        sftpConfigId: sftpConfigId,
        reportType: reportTypeMap[selectedReportType],
        scheduledTime: scheduleTime, // Format: "HH:mm"
        directoryPath: scheduleDirectoryPath || "/", // Directory path for file storage
      };

      // Add frequency based on execution type
      // Helper: format a date using local timezone parts to avoid UTC shift
      const toLocalDateTimeString = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}T00:00:00`;
      };

      if (executionType === "ONE_TIME") {
        scheduleData.frequency = "ONCE";
        // For one-time execution, include startDate with time
        if (scheduleStartDate) {
          scheduleData.startDate = toLocalDateTimeString(scheduleStartDate);
        }
      } else if (executionType === "RECURRING") {
        scheduleData.frequency = scheduleFrequency; // DAILY, WEEKLY, MONTHLY, YEARLY
        
        // Add startDate for recurring schedules
        if (scheduleStartDate) {
          scheduleData.startDate = toLocalDateTimeString(scheduleStartDate);
        }
        
        if (scheduleFrequency === "MONTHLY") {
          scheduleData.scheduleDay = parseInt(scheduleDayOfMonth);
        } else if (scheduleFrequency === "WEEKLY") {
          scheduleData.dayOfWeek = scheduleDayOfWeek;
        } else if (scheduleFrequency === "YEARLY") {
          // For yearly, you might need yearlyDate in MM-DD format
          if (scheduleStartDate) {
            const month = String(scheduleStartDate.getMonth() + 1).padStart(2, '0');
            const day = String(scheduleStartDate.getDate()).padStart(2, '0');
            scheduleData.yearlyDate = `${month}-${day}`;
          }
        }
      }
      
      // Add report-specific filters
      scheduleData.filters = {};
      
      if (selectedReportType === "clickData") {
        if (scheduleClickDataFilters.campaignName) {
          scheduleData.filters.campaignName = scheduleClickDataFilters.campaignName;
        }
        if (scheduleClickDataFilters.startDate) {
          scheduleData.filters.fromDate = formatDateForAPI(scheduleClickDataFilters.startDate);
        }
        if (scheduleClickDataFilters.endDate) {
          scheduleData.filters.toDate = formatDateForAPI(scheduleClickDataFilters.endDate);
        }
      } else if (selectedReportType === "urlHistory") {
        if (scheduleUrlHistoryFilters.campaignName) {
          scheduleData.filters.campaignName = scheduleUrlHistoryFilters.campaignName;
        }
        if (scheduleUrlHistoryFilters.senderId) {
          scheduleData.filters.senderId = scheduleUrlHistoryFilters.senderId;
        }
        if (scheduleUrlHistoryFilters.indivId) {
          scheduleData.filters.individualId = scheduleUrlHistoryFilters.indivId;
        }
        if (scheduleUrlHistoryFilters.startDate) {
          scheduleData.filters.fromDate = formatDateForAPI(scheduleUrlHistoryFilters.startDate);
        }
        if (scheduleUrlHistoryFilters.endDate) {
          scheduleData.filters.toDate = formatDateForAPI(scheduleUrlHistoryFilters.endDate);
        }
      } else if (selectedReportType === "creditHistory") {
        if (scheduleCreditHistoryFilters.transactionType) {
          scheduleData.filters.transactionType = scheduleCreditHistoryFilters.transactionType;
        }
        if (scheduleCreditHistoryFilters.creditType) {
          scheduleData.filters.creditType = scheduleCreditHistoryFilters.creditType;
        }
        if (scheduleCreditHistoryFilters.startDate) {
          scheduleData.filters.fromDate = formatDateForAPI(scheduleCreditHistoryFilters.startDate);
        }
        if (scheduleCreditHistoryFilters.endDate) {
          scheduleData.filters.toDate = formatDateForAPI(scheduleCreditHistoryFilters.endDate);
        }
      } else if (selectedReportType === "creditConsumption") {
        if (scheduleCreditConsumptionFilters.transactionType) {
          scheduleData.filters.transactionType = scheduleCreditConsumptionFilters.transactionType;
        }
        if (scheduleCreditConsumptionFilters.creditType) {
          scheduleData.filters.creditType = scheduleCreditConsumptionFilters.creditType;
        }
        if (scheduleCreditConsumptionFilters.startDate) {
          scheduleData.filters.fromDate = formatDateForAPI(scheduleCreditConsumptionFilters.startDate);
        }
        if (scheduleCreditConsumptionFilters.endDate) {
          scheduleData.filters.toDate = formatDateForAPI(scheduleCreditConsumptionFilters.endDate);
        }
      }
      
      console.log("Submitting schedule data:", scheduleData);

      if (isEditingSchedule && scheduleToEdit) {
        // Update existing schedule - PUT /api/sftp-configs/{accountId}/schedules/{scheduleId}
        await connectorService.updateSchedule(accountId, scheduleToEdit.id, scheduleData);
        toast.success("Export schedule updated successfully!");
        setIsEditingSchedule(false);
        setScheduleToEdit(null);
      } else {
        // Create new schedule - POST /api/sftp-configs/{accountId}/schedules
        const response = await connectorService.createSchedule(accountId, scheduleData);
        console.log("Schedule created response:", response);
        toast.success("Export schedule created successfully!");
      }
      
      // Reset schedule fields
      setExecutionType("ONE_TIME");
      setSelectedReportType("");
      setScheduleStartDate(null);
      setScheduleTime("");
      setScheduleFrequency("");
      setScheduleDayOfWeek("");
      setScheduleDayOfMonth("");
      setScheduleDirectoryPath("");
      setScheduleClickDataFilters({ campaignName: "", startDate: null, endDate: null });
      setScheduleUrlHistoryFilters({ campaignName: "", senderId: "", indivId: "", startDate: null, endDate: null });
      setScheduleCreditHistoryFilters({ transactionType: "", creditType: "", startDate: null, endDate: null });
      setScheduleCreditConsumptionFilters({ transactionType: "DEBIT", creditType: "", startDate: null, endDate: null });
      setSftpTestSuccess(false);
      setShowScheduleFields(false);
      
      // Refresh schedules list
      const schedulesResponse = await connectorService.getAllSchedules(accountId);
      if (schedulesResponse && schedulesResponse.success && schedulesResponse.data) {
        setSchedules(schedulesResponse.data);
      }
    } catch (error) {
      console.error("Error saving schedule:", error);
      toast.error(error.response?.data?.message || "Failed to save schedule");
    } finally {
      setSftpSubmitting(false);
    }
  };

  const handleExecuteScheduleNow = async (schedule) => {
    setExecutingScheduleId(schedule.id);
    try {
      const accountId = userRole === "SUPERADMIN" ? selectedAccountId : formData.accountId;
      await connectorService.executeScheduleNow(accountId, schedule.id);
      toast.success("Schedule execution started successfully!");
      
      // Refresh schedules list to update last execution time
      const schedulesResponse = await connectorService.getAllSchedules(accountId);
      if (schedulesResponse && schedulesResponse.success && schedulesResponse.data) {
        setSchedules(schedulesResponse.data);
      }
    } catch (error) {
      console.error("Error executing schedule:", error);
      toast.error(error.response?.data?.message || "Failed to execute schedule");
    } finally {
      setExecutingScheduleId(null);
    }
  };

  const handleDeleteScheduleClick = (schedule) => {
    setScheduleToDelete(schedule);
    setShowDeleteScheduleModal(true);
  };

  const confirmDeleteSchedule = async () => {
    if (!scheduleToDelete) return;

    try {
      const accountId = userRole === "SUPERADMIN" ? selectedAccountId : formData.accountId;
      await connectorService.deleteSchedule(accountId, scheduleToDelete.id);
      
      // Remove from local state
      setSchedules(prev => prev.filter(s => s.id !== scheduleToDelete.id));
      
      toast.success("Schedule deleted successfully!");
      setShowDeleteScheduleModal(false);
      setScheduleToDelete(null);
    } catch (error) {
      console.error("Error deleting schedule:", error);
      toast.error(error.response?.data?.message || "Failed to delete schedule");
    }
  };

  const handleEditScheduleClick = (schedule) => {
    setScheduleToEdit(schedule);
    setIsEditingSchedule(true);
    
    // Parse yearlyDate (MM-DD) into month and day if present
    let yearlyMonth = "";
    let yearlyDay = "";
    if (schedule.yearlyDate && schedule.yearlyDate.includes('-')) {
      const [month, day] = schedule.yearlyDate.split('-');
      yearlyMonth = month;
      yearlyDay = day;
    }
    
    // Populate form with schedule data
    setSftpFormData(prev => ({
      ...prev,
      schedule: schedule.frequency || "",
      time: schedule.scheduledTime || "",
      scheduleDay: schedule.scheduleDay ? schedule.scheduleDay.toString() : "",
      dayOfWeek: schedule.dayOfWeek || "",
      yearlyMonth: yearlyMonth,
      yearlyDay: yearlyDay,
    }));
    
    // Populate directory path
    setScheduleDirectoryPath(schedule.directoryPath || "");
    
    // Show schedule fields and hide test success
    setShowScheduleFields(true);
    setSftpTestSuccess(true);
    
    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const getFilteredAndSortedSchedules = () => {
    let filteredSchedules = [...schedules];

    // Filter by frequency
    if (scheduleFrequencyFilter !== "ALL") {
      filteredSchedules = filteredSchedules.filter(
        schedule => schedule.frequency === scheduleFrequencyFilter
      );
    }

    // Search by multiple fields
    if (scheduleSearchTerm) {
      const searchLower = scheduleSearchTerm.toLowerCase();
      filteredSchedules = filteredSchedules.filter(schedule =>
        schedule.frequency?.toLowerCase().includes(searchLower) ||
        schedule.reportType?.toLowerCase().includes(searchLower) ||
        schedule.scheduledTime?.toLowerCase().includes(searchLower) ||
        (schedule.isActive ? "active" : "inactive").includes(searchLower)
      );
    }

    // Sort
    if (scheduleSortField) {
      filteredSchedules.sort((a, b) => {
        let aValue = a[scheduleSortField];
        let bValue = b[scheduleSortField];

        // Handle null/undefined values
        if (aValue === null || aValue === undefined) return 1;
        if (bValue === null || bValue === undefined) return -1;

        // Convert to string for comparison
        aValue = String(aValue).toLowerCase();
        bValue = String(bValue).toLowerCase();

        if (scheduleSortOrder === "asc") {
          return aValue > bValue ? 1 : -1;
        } else {
          return aValue < bValue ? 1 : -1;
        }
      });
    }

    return filteredSchedules;
  };

  const handleScheduleSort = (field) => {
    if (scheduleSortField === field) {
      // Toggle sort order
      setScheduleSortOrder(scheduleSortOrder === "asc" ? "desc" : "asc");
    } else {
      setScheduleSortField(field);
      setScheduleSortOrder("asc");
    }
  };

  const handleViewScheduleHistory = async (schedule) => {
    // Check if we're viewing a different schedule
    const isDifferentSchedule = selectedScheduleForHistory?.id !== schedule.id;
    
    setSelectedScheduleForHistory(schedule);
    
    // Show and switch to Schedule History sub-tab
    setShowScheduleHistoryTab(true);
    setSftpSubTab("scheduleHistory");
    
    // Only fetch if it's a different schedule (clear cache and fetch new data)
    if (isDifferentSchedule) {
      setScheduleHistory([]);
      setHistorySearchTerm("");
      setHistorySortField(null);
      setHistorySortOrder("asc");
      setHistoryPage(0);
      await fetchScheduleHistory(schedule.id, 0);
    }
    // If same schedule and data exists, keep cached data
  };

  const fetchScheduleHistory = async (scheduleId, page = 0) => {
    setScheduleHistoryLoading(true);
    try {
      const accountId = userRole === "SUPERADMIN" ? selectedAccountId : formData.accountId;
      
      const response = await connectorService.getScheduleExportHistory(
        accountId, 
        scheduleId, 
        { page, size: historySize }
      );
      
      const payload =
        response && typeof response === "object" && "success" in response
          ? (response.success ? (response.data ?? {}) : null)
          : (response ?? {});

      if (payload) {
        const records = Array.isArray(payload)
          ? payload
          : payload.content || payload.items || payload.data || [];

        const parsedTotalPages =
          response?.totalPages ??
          payload.totalPages ??
          payload.pagination?.totalPages ??
          payload.page?.totalPages;

        const parsedTotalElements =
          response?.totalElements ??
          response?.totalItems ??
          payload.totalElements ??
          payload.totalItems ??
          payload.pagination?.totalElements ??
          payload.page?.totalElements;

        const safeTotalPages =
          Number(parsedTotalPages) > 0
            ? Number(parsedTotalPages)
            : Number(parsedTotalElements) > 0
              ? Math.ceil(Number(parsedTotalElements) / historySize)
              : records.length === historySize
                ? page + 2
                : records.length > 0
                  ? page + 1
                  : 0;

        setScheduleHistory(Array.isArray(records) ? records : []);
        setHistoryTotalPages(safeTotalPages);
        setHistoryPage(Math.max(0, Math.min(page, Math.max(safeTotalPages - 1, 0))));
      } else {
        setScheduleHistory([]);
        setHistoryTotalPages(0);
      }
    } catch (error) {
      console.error("Error fetching schedule history:", error);
      toast.error("Failed to load schedule history");
      setScheduleHistory([]);
    } finally {
      setScheduleHistoryLoading(false);
    }
  };

  const handleHistorySort = (field) => {
    if (historySortField === field) {
      setHistorySortOrder(historySortOrder === "asc" ? "desc" : "asc");
    } else {
      setHistorySortField(field);
      setHistorySortOrder("asc");
    }
  };

  const getFilteredAndSortedHistory = () => {
    let filteredHistory = [...scheduleHistory];

    // Search
    if (historySearchTerm) {
      const searchLower = historySearchTerm.toLowerCase();
      filteredHistory = filteredHistory.filter(record =>
        record.status?.toLowerCase().includes(searchLower) ||
        record.fileName?.toLowerCase().includes(searchLower) ||
        record.exportedAt?.toLowerCase().includes(searchLower)
      );
    }

    // Sort
    if (historySortField) {
      filteredHistory.sort((a, b) => {
        let aValue = a[historySortField];
        let bValue = b[historySortField];

        if (aValue === null || aValue === undefined) return 1;
        if (bValue === null || bValue === undefined) return -1;

        // For numeric fields like fileSizeBytes
        if (historySortField === 'fileSizeBytes') {
          aValue = Number(aValue);
          bValue = Number(bValue);
          return historySortOrder === "asc" ? aValue - bValue : bValue - aValue;
        }

        // For string fields
        aValue = String(aValue).toLowerCase();
        bValue = String(bValue).toLowerCase();

        if (historySortOrder === "asc") {
          return aValue > bValue ? 1 : -1;
        } else {
          return aValue < bValue ? 1 : -1;
        }
      });
    }

    return filteredHistory;
  };

  const handleHistoryPageChange = (newPage) => {
    if (selectedScheduleForHistory) {
      fetchScheduleHistory(selectedScheduleForHistory.id, newPage);
    }
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return 'N/A';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  };

  const calculateNextExecutionTime = (schedule) => {
    if (!schedule.isActive) return null;
    if (!schedule.startDate || !schedule.scheduledTime) return null;
    
    const now = new Date();
    const [hours, minutes] = schedule.scheduledTime.split(':').map(Number);
    
    try {
      switch (schedule.frequency) {
        case 'ONCE': {
          // For one-time, return startDate with scheduled time
          const executionDate = new Date(schedule.startDate);
          executionDate.setHours(hours, minutes, 0, 0);
          
          // Only return if it's in the future
          return executionDate > now ? executionDate : null;
        }
        
        case 'DAILY': {
          // Next execution is today or tomorrow at scheduled time
          let nextExec = new Date();
          nextExec.setHours(hours, minutes, 0, 0);
          
          // If today's time has passed, move to tomorrow
          if (nextExec <= now) {
            nextExec.setDate(nextExec.getDate() + 1);
          }
          
          return nextExec;
        }
        
        case 'WEEKLY': {
          if (!schedule.dayOfWeek) return null;
          
          const daysOfWeek = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
          const targetDay = daysOfWeek.indexOf(schedule.dayOfWeek);
          
          let nextExec = new Date();
          nextExec.setHours(hours, minutes, 0, 0);
          
          // Calculate days until target day
          const currentDay = nextExec.getDay();
          let daysUntil = targetDay - currentDay;
          
          // If target day is today but time has passed, go to next week
          if (daysUntil === 0 && nextExec <= now) {
            daysUntil = 7;
          } else if (daysUntil < 0) {
            daysUntil += 7;
          }
          
          nextExec.setDate(nextExec.getDate() + daysUntil);
          return nextExec;
        }
        
        case 'MONTHLY': {
          if (!schedule.scheduleDay) return null;
          
          let nextExec = new Date();
          nextExec.setDate(schedule.scheduleDay);
          nextExec.setHours(hours, minutes, 0, 0);
          
          // If this month's date has passed, move to next month
          if (nextExec <= now) {
            nextExec.setMonth(nextExec.getMonth() + 1);
          }
          
          return nextExec;
        }
        
        case 'YEARLY': {
          if (!schedule.yearlyDate) return null;
          
          const [month, day] = schedule.yearlyDate.split('-').map(Number);
          let nextExec = new Date();
          nextExec.setMonth(month - 1); // months are 0-indexed
          nextExec.setDate(day);
          nextExec.setHours(hours, minutes, 0, 0);
          
          // If this year's date has passed, move to next year
          if (nextExec <= now) {
            nextExec.setFullYear(nextExec.getFullYear() + 1);
          }
          
          return nextExec;
        }
        
        default:
          return null;
      }
    } catch (error) {
      console.error('Error calculating next execution time:', error);
      return null;
    }
  };
  

  const renderSearchTerms = () => {
    switch (activeTab) {
      case 'clickData':
        return (
          <>
            {userRole === "SUPERADMIN" && clickDataAccountId && (
              <Row className="mb-2 align-items-center">
                <Col sm={6} className="text-start">
                  <h6 className="mb-0 text-616161 fw-400 fs-12">Account</h6>
                </Col>
                <Col sm={6} className="text-start">
                  <p className="mb-0 fs-14 text-dark fw-600">
                    {accounts.find(acc => acc.id === clickDataAccountId)?.accountName}
                  </p>
                </Col>
              </Row>
            )}
            {filter.column && filter.value && (
              <Row className="mb-2 align-items-center">
                <Col sm={6} className="text-start">
                  <h6 className="mb-0 text-616161 fw-400 fs-12">{filter.column}</h6>
                </Col>
                <Col sm={6} className="text-start">
                  <p className="mb-0 fs-14 text-dark fw-600">{filter.value}</p>
                </Col>
              </Row>
            )}
          </>
        );
      case 'urlHistory':
        return (
          <>
            {userRole === "SUPERADMIN" && urlHistoryAccountId && (
              <Row className="mb-2 align-items-center">
                <Col sm={6} className="text-start">
                  <h6 className="mb-0 text-616161 fw-400 fs-12">Account</h6>
                </Col>
                <Col sm={6} className="text-start">
                  <p className="mb-0 fs-14 text-dark fw-600">
                    {accounts.find(acc => acc.id === urlHistoryAccountId)?.accountName}
                  </p>
                </Col>
              </Row>
            )}
            {Object.entries(urlHistoryFilters).map(([key, value]) => 
              value && (
                <Row key={key} className="mb-2 align-items-center">
                  <Col sm={6} className="text-start">
                    <h6 className="mb-0 text-616161 fw-400 fs-12">
                      {key === "campaignName" ? "Campaign" : 
                       key === "senderId" ? "Sender ID" : 
                       key === "indivId" ? "Individual ID" : key}
                    </h6>
                  </Col>
                  <Col sm={6} className="text-start">
                    <p className="mb-0 fs-14 text-dark fw-600">{value}</p>
                  </Col>
                </Row>
              )
            )}
          </>
        );
      case 'creditHistory':
        return (
          <>
            {userRole === "SUPERADMIN" && creditHistoryAccountId && (
              <Row className="mb-2 align-items-center">
                <Col sm={6} className="text-start">
                  <h6 className="mb-0 text-616161 fw-400 fs-12">Account</h6>
                </Col>
                <Col sm={6} className="text-start">
                  <p className="mb-0 fs-14 text-dark fw-600">
                    {accounts.find(acc => acc.id === creditHistoryAccountId)?.accountName}
                  </p>
                </Col>
              </Row>
            )}
            {Object.entries(creditHistoryFilters).map(([key, value]) => 
              value && (
                <Row key={key} className="mb-2 align-items-center">
                  <Col sm={6} className="text-start">
                    <h6 className="mb-0 text-616161 fw-400 fs-12">
                      {key === "transactionType" ? "Transaction Type" : 
                       key === "creditType" ? "Credit Type" : key}
                    </h6>
                  </Col>
                  <Col sm={6} className="text-start">
                    <p className="mb-0 fs-14 text-dark fw-600">{value}</p>
                  </Col>
                </Row>
              )
            )}
          </>
        );
      case 'creditConsumption':
        return (
          <>
            {userRole === "SUPERADMIN" && creditConsumptionAccountId && (
              <Row className="mb-2 align-items-center">
                <Col sm={6} className="text-start">
                  <h6 className="mb-0 text-616161 fw-400 fs-12">Account</h6>
                </Col>
                <Col sm={6} className="text-start">
                  <p className="mb-0 fs-14 text-dark fw-600">
                    {accounts.find(acc => acc.id === creditConsumptionAccountId)?.accountName}
                  </p>
                </Col>
              </Row>
            )}
            {Object.entries(creditConsumptionFilters).map(([key, value]) => 
              value && (
                <Row key={key} className="mb-2 align-items-center">
                  <Col sm={6} className="text-start">
                    <h6 className="mb-0 text-616161 fw-400 fs-12">
                      {key === "transactionType" ? "Transaction Type" : 
                       key === "creditType" ? "Credit Type" : key}
                    </h6>
                  </Col>
                  <Col sm={6} className="text-start">
                    <p className="mb-0 fs-14 text-dark fw-600">{value}</p>
                  </Col>
                </Row>
              )
            )}
          </>
        );
      default:
        return null;
    }
  };

  return (
    <Container fluid className="p-4 mt-5">
      <Card className="card-nostyle border-0 shadow-none">
        <Card.Body className="ps-0 pe-0">
          <div
            className="d-flex justify-content-between ps-4 pe-4 align-items-center"
            style={{ borderBottom: "1px solid #EAECF0" }}
          >
            <h4 className="mb-0 bg-white br-radius-12 rounded-bottom-0 pb-3 fs-20 poppins fw-600">
              <Image src={reportsIcon} className="me-1" width="12" /> Reports
            </h4>
          </div>
        </Card.Body>
      </Card>

      <div className="main-container pt-0">
        <Row>
          <Col lg={12}>
            <Card className="br-radius-12 card-nostyle">
              <Card.Body className="p-0">
                <Tabs
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  id="reports-tabs"
                  className="mb-4 cust-tab border-bottom"
                  justify
                >
                  <Tab eventKey="clickData" title="Click Data">
                    <div className="main-container p-0">
                      <Row>
                        <Col lg={12}>
                          <Card className="br-radius-0 card-nostyle">
                            <Card.Header className="bg-white border-0 br-radius-12 rounded-bottom-0 fs-20 d-flex p-0">
                              {/* {clickData.length > 0 && (
                                <Button 
                                  variant="outline-success" 
                                  onClick={handleDownloadCSV}
                                  disabled={downloading}
                                  className="rounded-pill d-flex align-items-center ms-auto"
                                  style={{ whiteSpace: 'nowrap' }}
                                >
                                  {downloading ? (
                                    <>
                                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                      <span>Downloading...</span>
                                    </>
                                  ) : (
                                    <>
                                      <FaFileDownload className="me-2" />
                                      <span>Download CSV</span>
                                    </>
                                  )}
                                </Button>
                              )} */}
                            </Card.Header>

                            <Card.Body className="p-0">
                              {/* <div className="d-flex justify-content-between align-items-center mb-4">
                                <div className="d-flex align-items-center gap-3">
                                  <Dropdown
                                    show={isFilterDropdownOpen}
                                    onToggle={(isOpen) =>
                                      setIsFilterDropdownOpen(isOpen)
                                    }
                                  >
                                    <Dropdown.Toggle
                                      variant="white"
                                      className="d-flex align-items-center gap-2 br-radius-8"
                                      style={{
                                        border: `1px solid ${
                                          isFilterDropdownOpen
                                            ? "#28a745"
                                            : "#EAECEE"
                                        }`, // green when open
                                      }}
                                    >
                                      <Image src={filterLinesIcon} width={12} />{" "}
                                      <span className="fw-400 fs-12">
                                        Filter
                                      </span>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu
                                      className="p-3 mt-2"
                                      style={{ width: "400px" }}
                                    >
                                      <div>
                                        {userRole === "SUPERADMIN" && (
                                          <Form.Group className="mb-3">
                                            <Form.Label className="fs-12">
                                              Account Name
                                            </Form.Label>
                                            <Form.Select
                                              value={selectedAccountId}
                                              onChange={(e) =>
                                                handleAccountChange(
                                                  e.target.value
                                                )
                                              }
                                              className=""
                                            >
                                              <option value="">
                                                Select Account
                                              </option>
                                              {accounts.map((account) => (
                                                <option
                                                  key={account.id}
                                                  value={account.id}
                                                >
                                                  {account.accountName}
                                                </option>
                                              ))}
                                            </Form.Select>
                                          </Form.Group>
                                        )}

                                        <Form.Group className="mb-2">
                                          <Form.Select
                                            value={filter.column}
                                            onChange={(e) => {
                                              handleFilterChange(
                                                "column",
                                                e.target.value
                                              );
                                              handleFilterChange("value", "");
                                            }}
                                            className=""
                                          >
                                            <option value="">
                                              Select column...
                                            </option>
                                            <option value="campaignName">
                                              Campaign Name
                                            </option>
                                          </Form.Select>
                                        </Form.Group>

                                        {filter.column && (
                                          <Form.Group className="mb-3">
                                            <Form.Control
                                              type="text"
                                              value={filter.value}
                                              onChange={(e) =>
                                                handleFilterChange(
                                                  "value",
                                                  e.target.value
                                                )
                                              }
                                              placeholder="Enter campaign name"
                                              className=""
                                            />
                                          </Form.Group>
                                        )}

                                        <div className="mb-3">
                                          <label className="fs-12 text-616161 mb-2">
                                            Date Range
                                          </label>
                                          <div
                                            className="d-flex align-items-center justify-content-between overflow-hidden"
                                            style={{
                                              border: "1px solid #EAECEE",
                                              borderRadius: "8px",
                                            }}
                                          >
                                            <DatePicker
                                              selected={startDate}
                                              onChange={(date) =>
                                                handleDateChange(date, true)
                                              }
                                              className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                              placeholderText="Start Date"
                                              maxDate={endDate || new Date()}
                                              minDate={userRole === "SUPERADMIN" && clickDataAccountId && accountCreatedAt ? accountCreatedAt : userCreatedAt}
                                              dateFormat="MMM dd, yyyy"
                                              showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                              isClearable={false}
                                            />

                                            <span className="mx-2">⇆</span>

                                            <DatePicker
                                              selected={endDate}
                                              onChange={(date) =>
                                                handleDateChange(date, false)
                                              }
                                              className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                              placeholderText="End Date"
                                              minDate={startDate}
                                              maxDate={new Date()}
                                              dateFormat="MMM dd, yyyy"
                                              showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                              isClearable={false}
                                            />

                                            <CiCalendar
                                              className={`me-2 ${
                                                startDate || endDate
                                                  ? "text-danger"
                                                  : ""
                                              }`}
                                              style={{ cursor: "pointer", fontSize: "20px" }}
                                              onClick={() => {
                                                setStartDate(null);
                                                setEndDate(null);
                                              }}
                                              title="Clear dates"
                                            />
                                          </div>
                                        </div>

                                        <div className="d-flex justify-content-center gap-2 mt-3">
                                          <Button
                                            variant="light"
                                            size="sm"
                                            onClick={() => {
                                              setFilter({
                                                column: "",
                                                value: "",
                                              });
                                              setStartDate(null);
                                              setEndDate(null);
                                              setClickData([]);
                                              setDownloading(false);
                                              setExporting(false);
                                            }}
                                            className=""
                                          >
                                            Clear all
                                          </Button>
                                          <Button
                                            variant="success"
                                            size="sm"
                                            onClick={fetchClickData}
                                            disabled={loading || !startDate || !endDate}
                                            className="br-radius-8"
                                          >
                                            {loading ? (
                                              <>
                                                <Spinner
                                                  size="sm"
                                                  className="me-1"
                                                />
                                                Applying...
                                              </>
                                            ) : (
                                              "Apply"
                                            )}
                                          </Button>
                                        </div>
                                      </div>
                                    </Dropdown.Menu>
                                  </Dropdown>

                                  <div className="d-flex gap-2 align-items-center flex-wrap">
                                    {userRole === "SUPERADMIN" &&
                                      selectedAccountId && (
                                        <div
                                          className="d-flex align-items-center gap-2"
                                          style={{
                                            border: "1px solid #EAECEE",
                                            padding: "10px 20px",
                                          }}
                                        >
                                          <span className="fs-12">
                                            Account:{" "}
                                            {
                                              accounts.find(
                                                (acc) =>
                                                  acc.id === selectedAccountId
                                              )?.accountName
                                            }
                                          </span>
                                          <Button
                                            variant="link"
                                            onClick={() => {
                                              setSelectedAccountId("");
                                              setFormData((prev) => ({
                                                ...prev,
                                                accountId: "",
                                              }));
                                              if (activeTab === "clickData") {
                                                setClickData([]);
                                              } else if (
                                                activeTab === "urlHistory"
                                              ) {
                                                setUrlHistory([]);
                                              } else if (
                                                activeTab === "creditHistory"
                                              ) {
                                                setCreditHistory([]);
                                              }
                                            }}
                                            className="p-0 text-danger"
                                            size="sm"
                                          >
                                            <FaTrash size={12} />
                                          </Button>
                                        </div>
                                      )}
                                    {filter.column && filter.value && (
                                      <div
                                        className="d-flex align-items-center gap-2 br-radius-8"
                                        style={{
                                          padding: "10px 20px",
                                          border: "1px solid #EAECEE",
                                        }}
                                      >
                                        <span className="fs-12">
                                          {filter.column}:{" "}
                                          <span className="fw-600">
                                            {filter.value}
                                          </span>
                                        </span>
                                        <Button
                                          variant="link"
                                          onClick={() =>
                                            setFilter({ column: "", value: "" })
                                          }
                                          className="p-0 text-danger ms-3"
                                          size="sm"
                                        >
                                          <CiTrash size={14} />
                                        </Button>
                                      </div>
                                    )}
                                    {(() => {
                                      let currentStartDate, currentEndDate;

                                      if (activeTab === "clickData") {
                                        currentStartDate = startDate;
                                        currentEndDate = endDate;
                                      } else if (activeTab === "urlHistory") {
                                        currentStartDate = urlHistoryStartDate;
                                        currentEndDate = urlHistoryEndDate;
                                      } else if (
                                        activeTab === "creditHistory"
                                      ) {
                                        currentStartDate =
                                          creditHistoryStartDate;
                                        currentEndDate = creditHistoryEndDate;
                                      }

                                      return (
                                        (currentStartDate ||
                                          currentEndDate) && (
                                          <div
                                            className="d-flex align-items-center gap-2 br-radius-8"
                                            style={{
                                              padding: "10px 20px",
                                              border: "1px solid #EAECEE",
                                            }}
                                          >
                                            <span className="fs-12">
                                              Date Range:{" "}
                                              <span className="fw-600">
                                                {currentStartDate
                                                  ? currentStartDate.toLocaleDateString()
                                                  : "Any"}{" "}
                                                -{" "}
                                                {currentEndDate
                                                  ? currentEndDate.toLocaleDateString()
                                                  : "Any"}
                                              </span>
                                            </span>
                                            <Button
                                              variant="link"
                                              onClick={() => {
                                                if (activeTab === "clickData") {
                                                  setStartDate(null);
                                                  setEndDate(null);
                                                } else if (
                                                  activeTab === "urlHistory"
                                                ) {
                                                  setUrlHistoryStartDate(null);
                                                  setUrlHistoryEndDate(null);
                                                } else if (
                                                  activeTab === "creditHistory"
                                                ) {
                                                  setCreditHistoryStartDate(
                                                    null
                                                  );
                                                  setCreditHistoryEndDate(null);
                                                }
                                              }}
                                              className="p-0 text-danger ms-3"
                                              size="sm"
                                            >
                                              <CiTrash size={14} />
                                            </Button>
                                          </div>
                                        )
                                      );
                                    })()}
                                  </div>
                                </div>
                              </div> */}

                              <div className="mb-4">
                                <div className="d-flex align-items-center gap-2">
                                  <Dropdown
                                    show={clickDataFilterOpen}
                                    onToggle={(isOpen) => setClickDataFilterOpen(isOpen)}
                                  >
                                    <Dropdown.Toggle
                                      variant="white"
                                      className="d-flex cus-dropdown-toggle-show align-items-center gap-2 br-radius-8"
                                      style={{
                                        border: `1px solid ${clickDataFilterOpen ? "#28a745" : "#EAECEE"}`,
                                      }}
                                    >
                                      {/* <Image src={filterLinesIcon} width={12} />  */}
                                      <IoFilterOutline className="me-2" />
                                      <span className="fw-400 fs-12">Filter</span>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="p-3 mt-2" style={{ width: "400px" }}>
                                      <div>
                                        {userRole === "SUPERADMIN" && (
                                          <Form.Group className="mb-3">
                                            <Form.Label className="fs-12">
                                              Account Name <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                              value={clickDataAccountId}
                                              onChange={(e) => handleAccountChange(e.target.value)}
                                              className=""
                                            >
                                              <option value="">Select Account</option>
                                              {accounts.map((account) => (
                                                <option key={account.id} value={account.id}>
                                                  {account.accountName}
                                                </option>
                                              ))}
                                            </Form.Select>
                                          </Form.Group>
                                        )}

                                        <Form.Group className="mb-2">
                                          <Form.Select
                                            value={filter.column}
                                            onChange={(e) => {
                                              handleFilterChange(
                                                "column",
                                                e.target.value
                                              );
                                              handleFilterChange("value", "");
                                            }}
                                            className=""
                                          >
                                            <option value="">
                                              Select column...
                                            </option>
                                            <option value="campaignName">
                                              Campaign Name
                                            </option>
                                          </Form.Select>
                                        </Form.Group>

                                        {filter.column && userRole === "SUPERADMIN" && (
                                          <Form.Group className="mb-3">
                                            <Form.Select
                                              value={filter.value}
                                              onChange={(e) =>
                                                handleFilterChange(
                                                  "value",
                                                  e.target.value
                                                )
                                              }
                                              disabled={clickDataCampaignsLoading}
                                              className=""
                                            >
                                              <option value="">
                                                {clickDataCampaignsLoading 
                                                  ? "Loading campaigns..." 
                                                  : "Select campaign name"}
                                              </option>
                                              {clickDataCampaigns.map((campaign) => (
                                                <option key={campaign} value={campaign}>
                                                  {campaign}
                                                </option>
                                              ))}
                                            </Form.Select>
                                          </Form.Group>
                                        )}

                                        {filter.column && userRole !== "SUPERADMIN" &&(
                                          <Form.Group className="mb-3">
                                            <Form.Control
                                              type="text"
                                              value={filter.value}
                                              onChange={(e) =>
                                                handleFilterChange(
                                                  "value",
                                                  e.target.value
                                                )
                                              }
                                              placeholder="Enter campaign name"
                                              className=""
                                            />
                                          </Form.Group>
                                        )}

                                        <Form.Group className="mb-3">
                                          <Form.Check
                                            type="checkbox"
                                            id="uniqueRecordsCheckbox"
                                            label="Unique Records"
                                            checked={clickDataUnique}
                                            onChange={(e) => setClickDataUnique(e.target.checked)}
                                            className="fs-12"
                                          />
                                        </Form.Group>

                                        <div className="mb-3">
                                          <label className="fs-12 text-616161 mb-2">
                                            Date Range <span className="text-danger">*</span>
                                          </label>
                                          <div
                                            className="d-flex align-items-center justify-content-between overflow-hidden"
                                            style={{
                                              border: "1px solid #EAECEE",
                                              borderRadius: "8px",
                                            }}
                                          >
                                            <DatePicker
                                              selected={startDate}
                                              onChange={(date) =>
                                                handleDateChange(date, true)
                                              }
                                              className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                              placeholderText="Start Date"
                                              maxDate={endDate || new Date()}
                                              minDate={userCreatedAt}
                                              dateFormat="MMM dd, yyyy"
                                              showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                              isClearable={false}
                                            />

                                            <span className="mx-2">⇆</span>

                                            <DatePicker
                                              selected={endDate}
                                              onChange={(date) =>
                                                handleDateChange(date, false)
                                              }
                                              className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                              placeholderText="End Date"
                                              minDate={startDate}
                                              maxDate={new Date()}
                                              dateFormat="MMM dd, yyyy"
                                              showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                              isClearable={false}
                                            />

                                            <CiCalendar
                                              className={`me-2 ${
                                                startDate || endDate
                                                  ? "text-danger"
                                                  : ""
                                              }`}
                                              style={{ cursor: "pointer", fontSize: "20px" }}
                                              onClick={() => {
                                                setStartDate(null);
                                                setEndDate(null);
                                              }}
                                              title="Clear dates"
                                            />
                                          </div>
                                        </div>

                                        <div className="d-flex justify-content-center gap-2 mt-3">
                                          <Button
                                            variant="light"
                                            size="sm"
                                            onClick={() => {
                                              setFilter({
                                                column: "",
                                                value: "",
                                              });
                                              setStartDate(null);
                                              setEndDate(null);
                                              setClickDataUnique(false);
                                              setClickData([]);
                                              setDownloading(false);
                                              setExporting(false);
                                              if (userRole === "SUPERADMIN") {
                                                setClickDataAccountId("");
                                                setFormData((prev) => ({ ...prev, accountId: "" }));
                                              }
                                            }}
                                            className=""
                                          >
                                            Clear all
                                          </Button>
                                          <Button
                                            variant="success"
                                            size="sm"
                                            onClick={fetchClickData}
                                            disabled={
                                              loading || 
                                              !startDate || 
                                              !endDate || 
                                              (userRole === "SUPERADMIN" && !clickDataAccountId)
                                            }
                                            className="br-radius-8"
                                          >
                                            {loading ? (
                                              <>
                                                <Spinner
                                                  size="sm"
                                                  className="me-1"
                                                />
                                                Applying...
                                              </>
                                            ) : (
                                              "Apply"
                                            )}
                                          </Button>
                                        </div>
                                      </div>
                                    </Dropdown.Menu>
                                  </Dropdown>


                                  {activeTab === "clickData" && ((userRole === "SUPERADMIN" && clickDataAccountId) || 
                                    (filter.column && filter.value) || 
                                    startDate || 
                                    endDate) && (
                                    <Button
                                      variant="light"
                                      size="sm"
                                      className="d-flex align-items-center gap-2 br-radius-8"
                                      style={{
                                        border: "1px solid #EAECEE",
                                        padding: "9px 15px",
                                      }}
                                      onClick={() => {
                                        setFilter({ column: "", value: "" });
                                        setStartDate(null);
                                        setEndDate(null);
                                        setClickDataUnique(false);
                                        setDownloading(false);
                                        setExporting(false);
                                        if (userRole === "SUPERADMIN") {
                                          setClickDataAccountId("");
                                          setFormData((prev) => ({ ...prev, accountId: "" }));
                                        }
                                        setClickData([]);
                                      }}
                                    >
                                      <FcClearFilters size={12} />
                                      <span className="fw-400 fs-12">Clear All</span>
                                    </Button>
                                  )}
                                </div>
                              </div>

                              {loading ? (
                                <div className="text-center">
                                  <Spinner
                                    animation="border"
                                    variant="success"
                                  />
                                  <p className="mt-3 text-muted">
                                    Fetching your data...
                                  </p>
                                </div>
                              ) : clickData.length > 0 ? (
                                <div
                                  className="text-center"
                                  style={{
                                    background:
                                      "linear-gradient(180deg, #FFF2E5 0%, #FFFFFF 40.56%, #FFFFFF 97.56%)",
                                    width: "400px",
                                    margin: "0 auto",
                                    border: "1px solid #C2C2C2",
                                    boxShadow:
                                      "0px 10.03px 30.08px 0px #AAAAAA1F",
                                    borderRadius: "22px",
                                    padding: "35px 20px 30px 20px",
                                  }}
                                >
                                  <Image
                                    src={recordReadyIcon}
                                    width={60}
                                    className="mb-3"
                                  />
                                  <h5 className="mb-4 fw-600 poppins fs-16">
                                    Your Report is Ready!
                                  </h5>
                                  <Row className="mb-2 align-items-center">
                                    <Col sm={6} className="text-start">
                                      <h6 className="mb-0 text-616161 fw-400 fs-12">
                                        Total Records
                                      </h6>
                                    </Col>
                                    <Col sm={6} className="text-start">
                                      <p className="mb-0 fs-14 text-dark fw-600">
                                        {clickData.length}
                                      </p>
                                    </Col>
                                  </Row>
                                  <Row className="mb-2 align-items-center">
                                    <Col sm={6} className="text-start">
                                      <h6 className="mb-0 text-616161 fw-400 fs-12">
                                        Date Range
                                      </h6>
                                    </Col>
                                    <Col sm={6} className="text-start">
                                      <p className="mb-0 fs-14 text-dark fw-600">
                                        {startDate
                                          ? startDate.toLocaleDateString()
                                          : "N/A"}{" "}
                                        to{" "}
                                        {endDate
                                          ? endDate.toLocaleDateString()
                                          : "N/A"}
                                      </p>
                                    </Col>
                                  </Row>

                                  {((userRole === "SUPERADMIN" && clickDataAccountId) || 
                                    (filter.column && filter.value) || 
                                    startDate || 
                                    endDate) && (
                                    <hr className="my-3" style={{ borderColor: "#EAECEE" }} />
                                  )}

                                  {renderSearchTerms()}


                                  <div className="mt-4 d-flex gap-3 justify-content-center">
                                    <Button
                                      variant="success"
                                      onClick={handleDownloadCSV}
                                      disabled={downloading}
                                      className="d-flex align-items-center br-radius-8"
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      {downloading ? (
                                        <>
                                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                          <span>Downloading...</span>
                                        </>
                                      ) : (
                                        <span>Download CSV</span>
                                      )}
                                    </Button>
                                    {canAccessSftpConfiguration && (
                                      <Button
                                        variant="outline-success"
                                        onClick={() => navigateToScheduleExport("clickData")}
                                        className="d-flex align-items-center br-radius-8"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        <span>Export CSV</span>
                                      </Button>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="text-center">
                                  <Image
                                    src={noRecordFound}
                                    width={100}
                                    className="mb-3"
                                  />
                                  <h5 className="mb-1 fs-14 fw-600">
                                    No Records Found !
                                  </h5>
                                  <p className="text-muted">
                                    Use the search form above to generate your
                                    click data report
                                  </p>
                                </div>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  </Tab>

                  <Tab eventKey="urlHistory" title="URL Shortening">
                    <div className="main-container p-0">
                      <Row>
                        <Col lg={12}>
                          <Card className="br-radius-0 card-nostyle">
                            <Card.Header className="bg-white border-0 br-radius-12 rounded-bottom-0 fs-20 d-flex p-0 card-header">
                              {/* {urlHistory.length > 0 && (
                                <Button 
                                  variant="outline-success" 
                                  onClick={handleUrlHistoryDownload}
                                  disabled={isUrlHistoryDownloading}
                                  className="GeneralSansMedium"
                                  style={{ whiteSpace: 'nowrap' }}
                                >
                                  {isUrlHistoryDownloading ? (
                                    <>
                                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                      Downloading...
                                    </>
                                  ) : (
                                    'Download CSV'
                                  )}
                                </Button>
                              )} */}
                            </Card.Header>
                            <Card.Body className="p-0">
                              <div className="mb-4">
                                <div className="d-flex align-items-center gap-2">
                                  <Dropdown
                                    show={urlHistoryFilterOpen}
                                    onToggle={(isOpen) => setUrlHistoryFilterOpen(isOpen)}
                                  >
                                    <Dropdown.Toggle
                                      variant="white"
                                      className="d-flex cus-dropdown-toggle-show align-items-center gap-2 br-radius-8"
                                      style={{
                                        border: `1px solid ${urlHistoryFilterOpen ? "#28a745" : "#EAECEE"}`,
                                      }}
                                    >
                                      {/* <Image src={filterLinesIcon} width={12} /> */}
                                      <IoFilterOutline className="me-2" />
                                      <span className="fw-400 fs-12">Filter</span>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="p-3 mt-2" style={{ width: "400px" }}>
                                      <div>
                                        {userRole === "SUPERADMIN" && (
                                          <Form.Group className="mb-3">
                                            <Form.Label className="fs-12">
                                              Account Name
                                            </Form.Label>
                                            <Form.Select
                                              value={urlHistoryAccountId}
                                              onChange={(e) => handleAccountChange(e.target.value)}
                                              className=""
                                            >
                                              <option value="">Select Account</option>
                                              {accounts.map((account) => (
                                                <option key={account.id} value={account.id}>
                                                  {account.accountName}
                                                </option>
                                              ))}
                                            </Form.Select>
                                          </Form.Group>
                                        )}

                                       {userRole === "SUPERADMIN" && <Form.Group className="mb-3">
                                          <Form.Label className="fs-12">
                                            Campaign Name
                                          </Form.Label>
                                          <Form.Select
                                            value={
                                              urlHistoryFilters.campaignName
                                            }
                                            onChange={(e) =>
                                              handleUrlHistoryFilterChange(
                                                "campaignName",
                                                e.target.value
                                              )
                                            }
                                            disabled={urlHistoryCampaignsLoading}
                                          >
                                            <option value="">
                                              {urlHistoryCampaignsLoading 
                                                ? "Loading campaigns..." 
                                                : "Select campaign name"}
                                            </option>
                                            {urlHistoryCampaigns.map((campaign) => (
                                              <option key={campaign} value={campaign}>
                                                {campaign}
                                              </option>
                                            ))}
                                          </Form.Select>
                                        </Form.Group>}

                                      { userRole === "SUPERADMIN" && <Form.Group className="mb-3">
                                          <Form.Label className="fs-12">
                                            Sender ID
                                          </Form.Label>
                                          <Form.Select
                                            value={urlHistoryFilters.senderId}
                                            onChange={(e) =>
                                              handleUrlHistoryFilterChange(
                                                "senderId",
                                                e.target.value
                                              )
                                            }
                                            disabled={urlHistoryCampaignsLoading}
                                          >
                                            <option value="">
                                              {urlHistoryCampaignsLoading 
                                                ? "Loading sender IDs..." 
                                                : "Select sender ID"}
                                            </option>
                                            {urlHistorySenderIds.map((senderId) => (
                                              <option key={senderId} value={senderId}>
                                                {senderId}
                                              </option>
                                            ))}
                                          </Form.Select>
                                        </Form.Group>}

                                       { userRole !== "SUPERADMIN" &&<Form.Group className="mb-3">
                                          <Form.Label className="fs-12">
                                            Campaign Name
                                          </Form.Label>
                                          <Form.Control
                                            type="text"
                                            value={
                                              urlHistoryFilters.campaignName
                                            }
                                            onChange={(e) =>
                                              handleUrlHistoryFilterChange(
                                                "campaignName",
                                                e.target.value
                                              )
                                            }
                                            placeholder="Enter campaign name"
                                          />
                                        </Form.Group>}

                                       {userRole !== "SUPERADMIN" && <Form.Group className="mb-3">
                                          <Form.Label className="fs-12">
                                            Sender ID
                                          </Form.Label>
                                          <Form.Control
                                            type="text"
                                            value={urlHistoryFilters.senderId}
                                            onChange={(e) =>
                                              handleUrlHistoryFilterChange(
                                                "senderId",
                                                e.target.value
                                              )
                                            }
                                            placeholder="Enter sender ID"
                                          />
                                        </Form.Group>}

                                        <Form.Group className="mb-3">
                                          <Form.Label className="fs-12">
                                            Individual ID
                                          </Form.Label>
                                          <Form.Control
                                            type="text"
                                            value={urlHistoryFilters.indivId}
                                            onChange={(e) =>
                                              handleUrlHistoryFilterChange(
                                                "indivId",
                                                e.target.value
                                              )
                                            }
                                            placeholder="Enter individual ID"
                                          />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                          <Form.Label className="fs-12">
                                            Date Range <span className="text-danger">*</span>
                                          </Form.Label>
                                          <div
                                            className="d-flex align-items-center justify-content-between overflow-hidden"
                                            style={{
                                              border: "1px solid #EAECEE",
                                              borderRadius: "8px",
                                            }}
                                          >
                                            <DatePicker
                                              selected={urlHistoryStartDate}
                                              onChange={(date) =>
                                                handleUrlHistoryDateChange(
                                                  date,
                                                  true
                                                )
                                              }
                                              className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                              placeholderText="Start Date"
                                              maxDate={
                                                urlHistoryEndDate || new Date()
                                              }
                                              minDate={userRole === "SUPERADMIN" && urlHistoryAccountId && accountCreatedAt ? accountCreatedAt : userCreatedAt}
                                              dateFormat="MMM dd, yyyy"
                                              showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                            />

                                            <span className="mx-2">⇆</span>

                                            <DatePicker
                                              selected={urlHistoryEndDate}
                                              onChange={(date) =>
                                                handleUrlHistoryDateChange(
                                                  date,
                                                  false
                                                )
                                              }
                                              className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                              placeholderText="End Date"
                                              minDate={urlHistoryStartDate}
                                              maxDate={new Date()}
                                              dateFormat="MMM dd, yyyy"
                                               showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                            />

                                            <CiCalendar
                                              className={`me-2 ${
                                                urlHistoryStartDate ||
                                                urlHistoryEndDate
                                                  ? "text-danger"
                                                  : ""
                                              }`}
                                              style={{ cursor: "pointer", fontSize: "20px" }}
                                              onClick={() => {
                                                setUrlHistoryStartDate(null);
                                                setUrlHistoryEndDate(null);
                                                handleUrlHistorySearch();
                                              }}
                                              title="Clear dates"
                                            />
                                          </div>
                                        </Form.Group>

                                        <div className="d-flex justify-content-center gap-2 mt-3">
                                          <Button
                                            variant="light"
                                            size="sm"
                                            onClick={() => {
                                              clearUrlHistoryFilters();
                                              if (userRole === "SUPERADMIN") {
                                                setUrlHistoryAccountId("");
                                              }
                                              setUrlHistory([]);
                                            }}
                                            className=""
                                          >
                                            Clear all
                                          </Button>
                                          <Button
                                            variant="success"
                                            size="sm"
                                            onClick={handleUrlHistorySearch}
                                            disabled={
                                              isUrlHistorySearching || 
                                              !urlHistoryStartDate || 
                                              !urlHistoryEndDate || 
                                              (userRole === "SUPERADMIN" && !urlHistoryAccountId)
                                            }
                                            className="br-radius-8"
                                          >
                                            {isUrlHistorySearching ? (
                                              <>
                                                <Spinner size="sm" className="me-1" />
                                                Applying...
                                              </>
                                            ) : (
                                              "Apply"
                                            )}
                                          </Button>
                                        </div>
                                      </div>
                                    </Dropdown.Menu>
                                  </Dropdown>


                                  {activeTab === "urlHistory" && ((userRole === "SUPERADMIN" && urlHistoryAccountId) || 
                                    Object.values(urlHistoryFilters).some(value => value) || 
                                    urlHistoryStartDate || 
                                    urlHistoryEndDate) && (
                                    <Button
                                      variant="light"
                                      size="sm"
                                      className="d-flex align-items-center gap-2 br-radius-8"
                                      style={{
                                        border: "1px solid #EAECEE",
                                        padding: "9px 15px",
                                      }}
                                      onClick={() => {
                                        clearUrlHistoryFilters();
                                        if (userRole === "SUPERADMIN") {
                                          setUrlHistoryAccountId("");
                                        }
                                        setUrlHistory([]);
                                      }}
                                    >
                                      <FcClearFilters size={12} />
                                      <span className="fw-400 fs-12">Clear All</span>
                                    </Button>
                                  )}
                                </div>
                              </div>

                              {urlHistoryLoading ? (
                                <div className="text-center py-4">
                                  <Spinner animation="border" variant="success" />
                                  <p className="mt-3 text-muted">Loading URL history...</p>
                                </div>
                              ) : urlHistory.length > 0 ? (
                                <div
                                  className="text-center"
                                  style={{
                                    background: "linear-gradient(180deg, #FFF2E5 0%, #FFFFFF 40.56%, #FFFFFF 97.56%)",
                                    width: "400px",
                                    margin: "0 auto",
                                    border: "1px solid #C2C2C2",
                                    boxShadow: "0px 10.03px 30.08px 0px #AAAAAA1F",
                                    borderRadius: "22px",
                                    padding: "35px 20px 30px 20px",
                                  }}
                                >
                                  <Image src={recordReadyIcon} width={60} className="mb-3" />
                                  <h5 className="mb-4 fw-600 poppins fs-16">Your Report is Ready!</h5>
                                  <Row className="mb-2 align-items-center">
                                    <Col sm={6} className="text-start">
                                      <h6 className="mb-0 text-616161 fw-400 fs-12">Total Records</h6>
                                    </Col>
                                    <Col sm={6} className="text-start">
                                      <p className="mb-0 fs-14 text-dark fw-600">{urlTotalCount}</p>
                                    </Col>
                                  </Row>
                                  <Row className="mb-2 align-items-center">
                                    <Col sm={6} className="text-start">
                                      <h6 className="mb-0 text-616161 fw-400 fs-12">Date Range</h6>
                                    </Col>
                                    <Col sm={6} className="text-start">
                                      <p className="mb-0 fs-14 text-dark fw-600">
                                        {urlHistoryStartDate ? urlHistoryStartDate.toLocaleDateString() : "N/A"} to{" "}
                                        {urlHistoryEndDate ? urlHistoryEndDate.toLocaleDateString() : "N/A"}
                                      </p>
                                    </Col>
                                  </Row>


                                  {((userRole === "SUPERADMIN" && urlHistoryAccountId) || 
                                    Object.values(urlHistoryFilters).some(value => value)) && (
                                    <hr className="my-3" style={{ borderColor: "#EAECEE" }} />
                                  )}

                                  {userRole === "SUPERADMIN" && urlHistoryAccountId && (
                                    <Row className="mb-2 align-items-center">
                                      <Col sm={6} className="text-start">
                                        <h6 className="mb-0 text-616161 fw-400 fs-12">Account</h6>
                                      </Col>
                                      <Col sm={6} className="text-start">
                                        <p className="mb-0 fs-14 text-dark fw-600">
                                          {accounts.find(acc => acc.id === urlHistoryAccountId)?.accountName}
                                        </p>
                                      </Col>
                                    </Row>
                                  )}

                                  {Object.entries(urlHistoryFilters).map(([key, value]) => 
                                    value && (
                                      <Row key={key} className="mb-2 align-items-center">
                                        <Col sm={6} className="text-start">
                                          <h6 className="mb-0 text-616161 fw-400 fs-12">
                                            {key === "campaignName" ? "Campaign" : 
                                             key === "senderId" ? "Sender ID" : 
                                             key === "indivId" ? "Individual ID" : key}
                                          </h6>
                                        </Col>
                                        <Col sm={6} className="text-start">
                                          <p className="mb-0 fs-14 text-dark fw-600">{value}</p>
                                        </Col>
                                      </Row>
                                    )
                                  )}

                                  {/* Download and Export Buttons */}
                                  <div className="mt-4 d-flex gap-3 justify-content-center">
                                    <Button
                                      variant="success"
                                      onClick={handleUrlHistoryDownload}
                                      disabled={isUrlHistoryDownloading}
                                      className="d-flex align-items-center br-radius-8"
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      {isUrlHistoryDownloading ? (
                                        <>
                                          <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                                          <span>Downloading...</span>
                                        </>
                                      ) : (
                                        <span>Download CSV</span>
                                      )}
                                    </Button>
                                    {canAccessSftpConfiguration && (
                                      <Button
                                        variant="outline-success"
                                        onClick={() => navigateToScheduleExport("urlHistory")}
                                        className="d-flex align-items-center br-radius-8"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        <span>Export CSV</span>
                                      </Button>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="text-center py-4">
                                  <Image src={noRecordFound} width={100} className="mb-3" />
                                  <h5 className="mb-1 fs-14 fw-600">No Records Found</h5>
                                  <p className="text-muted">No URL history records match your search criteria</p>
                                </div>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  </Tab>

                  <Tab eventKey="creditHistory" title="Credit Record">
                    <div className="main-container p-0">
                      <Row>
                        <Col lg={12}>
                          <Card className="br-radius-0 card-nostyle">
                            <Card.Header className="bg-white border-0 br-radius-12 rounded-bottom-0 fs-20 d-flex p-0">
                            </Card.Header>
                            <Card.Body className="p-0">
                              <div className="mb-4">
                                <div className="d-flex align-items-center gap-2">
                                  <Dropdown>
                                    <Dropdown.Toggle
                                      variant="white"
                                      className="d-flex cus-dropdown-toggle-show align-items-center gap-2 br-radius-8"
                                      style={{
                                        border: `1px solid ${openDropdown === "creditHistory" ? "#28a745" : "#EAECEE"}`,
                                      }}
                                    >
                                      {/* <Image src={filterLinesIcon} width={12} /> */}
                                      <IoFilterOutline className="me-2" />
                                      <span className="fw-400 fs-12">Filter</span>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="p-3 mt-2" style={{ width: "400px" }}>
                                      {userRole === "SUPERADMIN" && (
                                        <Form.Group className="mb-3">
                                          <Form.Label className="fs-12">Account Name</Form.Label>
                                          <Form.Select
                                            value={creditHistoryAccountId}
                                            onChange={(e) => handleAccountChange(e.target.value)}
                                            className=""
                                          >
                                            <option value="">Select Account</option>
                                            {accounts.map((account) => (
                                              <option key={account.id} value={account.id}>
                                                {account.accountName}
                                              </option>
                                            ))}
                                          </Form.Select>
                                        </Form.Group>
                                      )}

                                      <Form.Group className="mb-3">
                                        <Form.Label className="fs-12">Transaction Type</Form.Label>
                                        <Form.Select
                                          value={creditHistoryFilters.transactionType}
                                          onChange={(e) =>
                                            handleCreditHistoryFilterChange("transactionType", e.target.value)
                                          }
                                          className="br-radius-8"
                                        >
                                          <option value="">Select Type</option>
                                          <option value="CREDIT">Credit</option>
                                          <option value="DEBIT">Debit</option>
                                        </Form.Select>
                                      </Form.Group>

                                      <Form.Group className="mb-3">
                                        <Form.Label className="fs-12">Credit Type</Form.Label>
                                        <Form.Select
                                          value={creditHistoryFilters.creditType}
                                          onChange={(e) =>
                                            handleCreditHistoryFilterChange("creditType", e.target.value)
                                          }
                                          className=""
                                        >
                                          <option value="">Select Credit Type</option>
                                          <option value="SHORTENING">Shortening</option>
                                          <option value="TRACKING">Tracking</option>
                                        </Form.Select>
                                      </Form.Group>

                                      <Form.Group className="mb-3">
                                        <Form.Label className="fs-12">Date Range <span className="text-danger">*</span></Form.Label>
                                          <div
                                            className="d-flex align-items-center justify-content-between overflow-hidden"
                                            style={{
                                              border: "1px solid #EAECEE",
                                              borderRadius: "8px",
                                            }}
                                          >
                                            <DatePicker
                                              selected={creditHistoryStartDate}
                                              onChange={(date) => handleCreditHistoryDateChange(date, true)}
                                              className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                              placeholderText="Start Date"
                                              maxDate={creditHistoryEndDate || new Date()}
                                              minDate={userRole === "SUPERADMIN" && creditHistoryAccountId && accountCreatedAt ? accountCreatedAt : userCreatedAt}
                                              dateFormat="MMM dd, yyyy"
                                               showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                            />

                                            <span className="mx-2">⇆</span>

                                            <DatePicker
                                              selected={creditHistoryEndDate}
                                              onChange={(date) => handleCreditHistoryDateChange(date, false)}
                                              className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                              placeholderText="End Date"
                                              minDate={creditHistoryStartDate}
                                              maxDate={new Date()}
                                              dateFormat="MMM dd, yyyy"
                                               showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                            />

                                            <CiCalendar
                                              className={`me-2 ${
                                                creditHistoryStartDate || creditHistoryEndDate
                                                  ? "text-danger"
                                                  : ""
                                              }`}
                                              style={{ cursor: "pointer", fontSize: "20px" }}
                                              onClick={() => {
                                                setCreditHistoryStartDate(null);
                                                setCreditHistoryEndDate(null);
                                              }}
                                              title="Clear dates"
                                            />
                                          </div>
                                      </Form.Group>

                                      <div className="d-flex justify-content-center gap-2 mt-3">
                                        <Button
                                          variant="light"
                                          size="sm"
                                          onClick={() => {
                                            setCreditHistoryFilters({
                                              transactionType: "",
                                              creditType: "",
                                            });
                                            setCreditHistoryStartDate(null);
                                            setCreditHistoryEndDate(null);
                                            if (userRole === "SUPERADMIN") {
                                              setCreditHistoryAccountId("");
                                            }
                                            setCreditHistory([]);
                                            setIsCreditHistoryDownloading(false);
                                            setIsCreditHistoryExporting(false);
                                          }}
                                        >
                                          Clear all
                                        </Button>
                                        <Button
                                          variant="success"
                                          size="sm"
                                          onClick={handleCreditHistorySearch}
                                          disabled={
                                            creditHistoryLoading || 
                                            !creditHistoryStartDate || 
                                            !creditHistoryEndDate || 
                                            (userRole === "SUPERADMIN" && !creditHistoryAccountId)
                                          }
                                          className="br-radius-8"
                                        >
                                          {creditHistoryLoading ? (
                                            <>
                                              <Spinner size="sm" className="me-1" />
                                              Applying...
                                            </>
                                          ) : (
                                            "Apply"
                                          )}
                                        </Button>
                                      </div>
                                    </Dropdown.Menu>
                                  </Dropdown>


                                  {activeTab === "creditHistory" && 
                                    ((userRole === "SUPERADMIN" && creditHistoryAccountId) || 
                                    Object.values(creditHistoryFilters).some(value => value) || 
                                    creditHistoryStartDate || 
                                    creditHistoryEndDate) && (
                                    <Button
                                      variant="light"
                                      size="sm"
                                      className="d-flex align-items-center gap-2 br-radius-8"
                                      style={{
                                        border: "1px solid #EAECEE",
                                        padding: "9px 15px",
                                      }}
                                      onClick={() => {
                                        setCreditHistoryFilters({
                                          transactionType: "",
                                          creditType: "",
                                        });
                                        setCreditHistoryStartDate(null);
                                        setCreditHistoryEndDate(null);
                                        setIsCreditHistoryDownloading(false);
                                        setIsCreditHistoryExporting(false);
                                        if (userRole === "SUPERADMIN") {
                                          setCreditHistoryAccountId("");
                                        }
                                        setCreditHistory([]);
                                      }}
                                    >
                                      <FcClearFilters size={12} />
                                      <span className="fw-400 fs-12">Clear All</span>
                                    </Button>
                                  )}
                                </div>
                              </div>

                              {creditHistoryLoading ? (
                                <div className="text-center py-4">
                                  <Spinner animation="border" variant="success" />
                                  <p className="mt-3 text-muted">Loading credit history...</p>
                                </div>
                              ) : creditHistory.length > 0 ? (
                                <div
                                  className="text-center"
                                  style={{
                                    background: "linear-gradient(180deg, #FFF2E5 0%, #FFFFFF 40.56%, #FFFFFF 97.56%)",
                                    width: "400px",
                                    margin: "0 auto",
                                    border: "1px solid #C2C2C2",
                                    boxShadow: "0px 10.03px 30.08px 0px #AAAAAA1F",
                                    borderRadius: "22px",
                                    padding: "35px 20px 30px 20px",
                                  }}
                                >
                                  <Image src={recordReadyIcon} width={60} className="mb-3" />
                                  <h5 className="mb-4 fw-600 poppins fs-16">Your Report is Ready!</h5>
                                  <Row className="mb-2 align-items-center">
                                    <Col sm={6} className="text-start">
                                      <h6 className="mb-0 text-616161 fw-400 fs-12">Total Records</h6>
                                    </Col>
                                    <Col sm={6} className="text-start">
                                      <p className="mb-0 fs-14 text-dark fw-600">{creditHistory.length}</p>
                                    </Col>
                                  </Row>
                                  <Row className="mb-2 align-items-center">
                                    <Col sm={6} className="text-start">
                                      <h6 className="mb-0 text-616161 fw-400 fs-12">Date Range</h6>
                                    </Col>
                                    <Col sm={6} className="text-start">
                                      <p className="mb-0 fs-14 text-dark fw-600">
                                        {creditHistoryStartDate ? creditHistoryStartDate.toLocaleDateString() : "N/A"} to{" "}
                                        {creditHistoryEndDate ? creditHistoryEndDate.toLocaleDateString() : "N/A"}
                                      </p>
                                    </Col>
                                  </Row>


                                  {((userRole === "SUPERADMIN" && creditHistoryAccountId) || 
                                    Object.values(creditHistoryFilters).some(value => value)) && (
                                    <hr className="my-3" style={{ borderColor: "#EAECEE" }} />
                                  )}

                                  {userRole === "SUPERADMIN" && creditHistoryAccountId && (
                                    <Row className="mb-2 align-items-center">
                                      <Col sm={6} className="text-start">
                                        <h6 className="mb-0 text-616161 fw-400 fs-12">Account</h6>
                                      </Col>
                                      <Col sm={6} className="text-start">
                                        <p className="mb-0 fs-14 text-dark fw-600">
                                          {accounts.find(acc => acc.id === creditHistoryAccountId)?.accountName}
                                        </p>
                                      </Col>
                                    </Row>
                                  )}

                                  {Object.entries(creditHistoryFilters).map(([key, value]) => 
                                    value && (
                                      <Row key={key} className="mb-2 align-items-center">
                                        <Col sm={6} className="text-start">
                                          <h6 className="mb-0 text-616161 fw-400 fs-12">
                                            {key === "transactionType" ? "Transaction Type" : 
                                             key === "creditType" ? "Credit Type" : key}
                                          </h6>
                                        </Col>
                                        <Col sm={6} className="text-start">
                                          <p className="mb-0 fs-14 text-dark fw-600">{value}</p>
                                        </Col>
                                      </Row>
                                    )
                                  )}


                                  <div className="mt-4 d-flex gap-3 justify-content-center">
                                    <Button
                                      variant="success br-radius-8"
                                      onClick={handleCreditHistoryDownload}
                                      disabled={isCreditHistoryDownloading}
                                      className="GeneralSansMedium"
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      {isCreditHistoryDownloading ? (
                                        <>
                                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                          Downloading...
                                        </>
                                      ) : (
                                        "Download CSV"
                                      )}
                                    </Button>
                                    {canAccessSftpConfiguration && (
                                      <Button
                                        variant="outline-success br-radius-8"
                                        onClick={() => navigateToScheduleExport("creditHistory")}
                                        className="GeneralSansMedium"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        Export CSV
                                      </Button>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="text-center py-4">
                                  <Image src={noRecordFound} width={100} className="mb-3" />
                                  <h5 className="mb-1 fs-14 fw-600">No Records Found</h5>
                                  <p className="text-muted">No credit history records match your search criteria</p>
                                </div>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  </Tab>

                  <Tab eventKey="creditConsumption" title="Credit Consumption">
                    <div className="main-container p-0">
                      <Row>
                        <Col lg={12}>
                          <Card className="br-radius-0 card-nostyle">
                            <Card.Header className="bg-white border-0 br-radius-12 rounded-bottom-0 fs-20 d-flex p-0">
                            </Card.Header>
                            <Card.Body className="p-0">
                              <div className="mb-4">
                                <div className="d-flex align-items-center gap-2">
                                  <Dropdown
                                    show={creditConsumptionFilterOpen}
                                    onToggle={(isOpen) => setCreditConsumptionFilterOpen(isOpen)}
                                  >
                                    <Dropdown.Toggle
                                      variant="white"
                                      className="d-flex cus-dropdown-toggle-show align-items-center gap-2 br-radius-8"
                                      style={{
                                        border: `1px solid ${creditConsumptionFilterOpen ? "#28a745" : "#EAECEE"}`,
                                      }}
                                    >
                                      {/* <Image src={filterLinesIcon} width={12} /> */}
                                      <IoFilterOutline className="me-2" />
                                      <span className="fw-400 fs-12">Filter</span>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="p-3 mt-2" style={{ width: "400px" }}>
                                      <div>
                                        {userRole === "SUPERADMIN" && (
                                          <Form.Group className="mb-3">
                                            <Form.Label className="fs-12">
                                              Account Name <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                              value={creditConsumptionAccountId}
                                              onChange={(e) => handleAccountChange(e.target.value)}
                                              className=""
                                            >
                                              <option value="">Select Account</option>
                                              {accounts.map((account) => (
                                                <option key={account.id} value={account.id}>
                                                  {account.accountName}
                                                </option>
                                              ))}
                                            </Form.Select>
                                          </Form.Group>
                                        )}

                                        <Form.Group className="mb-3">
                                          <Form.Label className="fs-12">
                                            Transaction Type
                                          </Form.Label>
                                          <Form.Control
                                            type="text"
                                            value="DEBIT"
                                            disabled
                                            className=""
                                          />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                          <Form.Label className="fs-12">
                                            Credit Type
                                          </Form.Label>
                                          <Form.Select
                                            value={
                                              creditConsumptionFilters.creditType
                                            }
                                            onChange={(e) =>
                                              handleCreditConsumptionFilterChange(
                                                "creditType",
                                                e.target.value
                                              )
                                            }
                                            className=""
                                          >
                                            <option value="">
                                              Select Credit Type
                                            </option>
                                            <option value="SHORTENING">
                                              Shortening
                                            </option>
                                            <option value="TRACKING">
                                              Tracking
                                            </option>
                                          </Form.Select>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                          <Form.Label className="fs-12">
                                            Date Range <span className="text-danger">*</span>
                                          </Form.Label>
                                          <div
                                            className="d-flex align-items-center justify-content-between overflow-hidden"
                                            style={{
                                              border: "1px solid #EAECEE",
                                              borderRadius: "8px",
                                            }}
                                          >
                                            <DatePicker
                                              selected={
                                                creditConsumptionStartDate
                                              }
                                              onChange={(date) =>
                                                handleCreditConsumptionDateChange(
                                                  date,
                                                  true
                                                )
                                              }
                                              className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                              placeholderText="Start Date"
                                              maxDate={
                                                creditConsumptionEndDate ||
                                                new Date()
                                              }
                                              minDate={userRole === "SUPERADMIN" && creditConsumptionAccountId && accountCreatedAt ? accountCreatedAt : userCreatedAt}
                                              showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                              dateFormat="MMM dd, yyyy"
                                            />

                                            <span className="mx-2">⇆</span>

                                            <DatePicker
                                              selected={
                                                creditConsumptionEndDate
                                              }
                                              onChange={(date) =>
                                                handleCreditConsumptionDateChange(
                                                  date,
                                                  false
                                                )
                                              }
                                              className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                              placeholderText="End Date"
                                              minDate={
                                                creditConsumptionStartDate
                                              }
                                              maxDate={new Date()}
                                              dateFormat="MMM dd, yyyy"
                                               showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                            />

                                            <CiCalendar
                                              className={`me-2 ${
                                                creditConsumptionStartDate ||
                                                creditConsumptionEndDate
                                                  ? "text-danger"
                                                  : ""
                                              }`}
                                              style={{ cursor: "pointer", fontSize: "20px" }}
                                              onClick={() => {
                                                setCreditConsumptionStartDate(
                                                  null
                                                );
                                                setCreditConsumptionEndDate(
                                                  null
                                                );
                                              }}
                                              title="Clear dates"
                                            />
                                          </div>
                                        </Form.Group>

                                        <div className="d-flex justify-content-center gap-2 mt-3">
                                          <Button
                                            variant="light"
                                            size="sm"
                                            onClick={() => {
                                              setCreditConsumptionFilters({
                                                transactionType: "DEBIT",
                                                creditType: "",
                                              });
                                              setCreditConsumptionStartDate(
                                                null
                                              );
                                              setCreditConsumptionEndDate(null);
                                              if (userRole === "SUPERADMIN") {
                                                setCreditConsumptionAccountId("");
                                              }
                                              setCreditConsumption([]);
                                              setCreditLength(0);
                                              setIsCreditConsumptionDownloading(false);
                                              setIsCreditConsumptionExporting(false);
                                            }}
                                            className=""
                                          >
                                            Clear all
                                          </Button>
                                          <Button
                                            variant="success"
                                            size="sm"
                                            onClick={handleCreditConsumptionSearch}
                                            disabled={
                                              creditConsumptionLoading || 
                                              !creditConsumptionStartDate || 
                                              !creditConsumptionEndDate || 
                                              (userRole === "SUPERADMIN" && !creditConsumptionAccountId)
                                            }
                                            className="br-radius-8"
                                          >
                                            {creditConsumptionLoading ? (
                                              <>
                                                <Spinner size="sm" className="me-1" />
                                                Applying...
                                              </>
                                            ) : (
                                              "Apply"
                                            )}
                                          </Button>
                                        </div>
                                      </div>
                                    </Dropdown.Menu>
                                  </Dropdown>


                                  {activeTab === "creditConsumption" && ((userRole === "SUPERADMIN" && creditConsumptionAccountId) || 
                                    Object.values(creditConsumptionFilters).some(value => value) || 
                                    creditConsumptionStartDate || 
                                    creditConsumptionEndDate) && (
                                    <Button
                                      variant="light"
                                      size="sm"
                                      className="d-flex align-items-center gap-2 br-radius-8"
                                      style={{
                                        border: "1px solid #EAECEE",
                                        padding: "9px 15px",
                                      }}
                                      onClick={() => {
                                        setCreditConsumptionFilters({
                                          transactionType: "DEBIT",
                                          creditType: "",
                                        });
                                        setCreditConsumptionStartDate(
                                          null
                                        );
                                        setCreditConsumptionEndDate(null);
                                        setIsCreditConsumptionDownloading(false);
                                        setIsCreditConsumptionExporting(false);
                                        setCreditLength(0);
                                        if (userRole === "SUPERADMIN") {
                                          setCreditConsumptionAccountId("");
                                        }
                                        setCreditConsumption([]);
                                      }}
                                    >
                                      <FcClearFilters size={12} />
                                      <span className="fw-400 fs-12">Clear All</span>
                                    </Button>
                                  )}
                                </div>
                              </div>

                              {creditConsumptionLoading ? (
                                <div className="text-center py-4">
                                  <Spinner
                                    animation="border"
                                    variant="success"
                                  />
                                  <p className="mt-3 text-muted">
                                    Loading credit consumption...
                                  </p>
                                </div>
                              ) : creditConsumption.length > 0 ? (
                                <div
                                  className="text-center"
                                  style={{
                                    background:
                                      "linear-gradient(180deg, #FFF2E5 0%, #FFFFFF 40.56%, #FFFFFF 97.56%)",
                                    width: "400px",
                                    margin: "0 auto",
                                    border: "1px solid #C2C2C2",
                                    boxShadow:
                                      "0px 10.03px 30.08px 0px #AAAAAA1F",
                                    borderRadius: "22px",
                                    padding: "35px 20px 30px 20px",
                                  }}
                                >
                                  <Image
                                    src={recordReadyIcon}
                                    width={60}
                                    className="mb-3"
                                  />
                                  <h5 className="mb-4 fw-600 poppins fs-16">
                                    Your Report is Ready!
                                  </h5>
                                  <Row className="mb-2 align-items-center">
                                    <Col sm={6} className="text-start">
                                      <h6 className="mb-0 text-616161 fw-400 fs-12">
                                        Total Records
                                      </h6>
                                    </Col>
                                    <Col sm={6} className="text-start">
                                      <p className="mb-0 fs-14 text-dark fw-600">
                                        {creditLength}
                                      </p>
                                    </Col>
                                  </Row>
                                  <Row className="mb-2 align-items-center">
                                    <Col sm={6} className="text-start">
                                      <h6 className="mb-0 text-616161 fw-400 fs-12">
                                        Date Range
                                      </h6>
                                    </Col>
                                    <Col sm={6} className="text-start">
                                      <p className="mb-0 fs-14 text-dark fw-600">
                                        {creditConsumptionStartDate
                                          ? creditConsumptionStartDate.toLocaleDateString()
                                          : "N/A"}{" "}
                                        to{" "}
                                        {creditConsumptionEndDate
                                          ? creditConsumptionEndDate.toLocaleDateString()
                                          : "N/A"}
                                      </p>
                                    </Col>
                                  </Row>

                                  {((userRole === "SUPERADMIN" && creditConsumptionAccountId) || 
                                    Object.values(creditConsumptionFilters).some(value => value) || 
                                    creditConsumptionStartDate || 
                                    creditConsumptionEndDate) && (
                                    <hr className="my-3" style={{ borderColor: "#EAECEE" }} />
                                  )}

                                  {renderSearchTerms()}


                                  <div className="mt-4 d-flex gap-3 justify-content-center">
                                    {creditConsumption.length > 0 && (
                                      <>
                                        <Button
                                          variant="success br-radius-8"
                                          onClick={
                                            handleCreditConsumptionDownload
                                          }
                                          disabled={
                                            isCreditConsumptionDownloading
                                          }
                                          className="GeneralSansMedium"
                                          style={{ whiteSpace: "nowrap" }}
                                        >
                                          {isCreditConsumptionDownloading ? (
                                            <>
                                              <span
                                                className="spinner-border spinner-border-sm me-2"
                                                role="status"
                                                aria-hidden="true"
                                              ></span>
                                              Downloading...
                                            </>
                                          ) : (
                                            "Download CSV"
                                          )}
                                        </Button>
                                        {canAccessSftpConfiguration && (
                                          <Button
                                            variant="outline-success br-radius-8"
                                            onClick={() => navigateToScheduleExport("creditConsumption")}
                                            className="GeneralSansMedium"
                                            style={{ whiteSpace: "nowrap" }}
                                          >
                                            Export CSV
                                          </Button>
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="text-center py-4">
                                  <Image
                                    src={noRecordFound}
                                    width={100}
                                    className="mb-3"
                                  />
                                  <h5 className="mb-1 fs-14 fw-600">
                                    No Records Found
                                  </h5>
                                  <p className="text-muted">
                                    No credit consumption records match your
                                    search criteria
                                  </p>
                                </div>
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  </Tab>

                  {canAccessSftpConfiguration && (
                   <Tab eventKey="sftpDestination" title="Click Data SFTP Configuration">
                    <div className="main-container p-0">
                      <Row>
                        <Col lg={12}>
                          <Card className="br-radius-0 card-nostyle">
                            <Card.Body className="p-0">
                              {/* Nested Tabs for SFTP Configuration */}
                              <Tabs
                                activeKey={sftpSubTab}
                                onSelect={(k) => setSftpSubTab(k)}
                                id="sftp-sub-tabs"
                                className="mb-4 cust-tab border-bottom"
                              >
                                <Tab eventKey="scheduleExport" title="Schedule Export">
                                  <div className="p-4">
                              {sftpConfigLoading ? (
                                <div className="text-center py-5">
                                  <Spinner animation="border" variant="success" />
                                  <p className="mt-3 text-muted">Loading SFTP configuration...</p>
                                </div>
                              ) : (
                                <>
                                <Card className="br-radius-12 card-nostyle" style={{ border: "1px solid #EAECEE" }}>
                                <Card.Body >
                                  {isEditingSchedule && (
                                    <div className="alert alert-info mb-3" style={{ backgroundColor: '#E8F4FD', border: '1px solid #B3D9F2', borderRadius: '8px' }}>
                                      <small className="text-616161">
                                        <strong>Note:</strong> SFTP configuration fields are locked while editing schedule. Cancel to modify configuration.
                                      </small>
                                    </div>
                                  )}
                                  
                                  {/* SFTP Configuration Selector */}
                                  {allSftpConfigs.length > 0 && !isEditingSchedule ? (
                                    <Row className="mb-4">
                                      <Col md={6}>
                                        <Form.Group>
                                          <Form.Label className="fs-12 fw-600">
                                            Select SFTP Configuration <span className="text-danger">*</span>
                                          </Form.Label>
                                          <Form.Select
                                            value={selectedConfigUsername}
                                            onChange={(e) => handleConfigurationSelect(e.target.value)}
                                            className="br-radius-8"
                                          >
                                            <option value="">Choose a configuration...</option>
                                            {allSftpConfigs.map((config) => (
                                              <option key={config.id} value={config.username}>
                                                {config.name ? `${config.name} (${config.host})` : `${config.username} (${config.host})`}
                                              </option>
                                            ))}
                                          </Form.Select>
                                          <Form.Text className="text-muted">
                                            Select an existing SFTP configuration to schedule exports
                                          </Form.Text>
                                        </Form.Group>
                                      </Col>
                                    </Row>
                                  ):  
                                   
                                    <div className="text-center py-4">
                                      <Image src={noRecordFound} width={100} className="mb-3" />
                                      <h5 className="mb-1 fs-14 fw-600">No Export Configurations Found</h5>
                                      <p className="text-muted">Create an Export Configuration first</p>
                                    </div>
                                    
                                  }

                                
                                  
                                  {/* Show form fields only when configuration is selected */}
                                  {selectedConfigUsername && (
                                  <>
                                  {testConnectionFailed && (
                                    <Row>
                                      <Col md={12}>
                                        <hr className="my-4" />
                                        <div className="alert alert-danger d-flex align-items-start gap-2 mb-0" style={{ backgroundColor: '#FEE', border: '1px solid #FCC', borderRadius: '8px' }}>
                                          <span style={{ fontSize: '20px' }}>✗</span>
                                          <div>
                                            <h6 className="mb-1 fw-600 text-danger">
                                              Connection Test Failed
                                            </h6>
                                            <p className="mb-0 text-danger fs-12">
                                              {testConnectionError}
                                            </p>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                  )}

                                  {showScheduleFields && (
                                    <>
                                      <Row>
                                        <Col md={12}>
                                          <hr className="my-4" />
                                          <h6 className={`mb-3 fw-600 ${isEditingSchedule ? 'text-101828' : 'text-success'}`}>
                                            {isEditingSchedule ? '✏️ Edit Schedule' : '✓ Connection Successful! Configure Schedule'}
                                          </h6>
                                        </Col>
                                      </Row>

                                      {/* Execution Type Radio Buttons */}
                                      <Row>
                                        <Col md={12}>
                                          <Form.Group className="mb-3">
                                            <Form.Label className="fs-12 fw-600">
                                              Execution Type <span className="text-danger">*</span>
                                            </Form.Label>
                                            <div className="d-flex gap-4">
                                              <Form.Check
                                                type="radio"
                                                id="execution-one-time"
                                                label="One Time Execution"
                                                name="executionType"
                                                value="ONE_TIME"
                                                checked={executionType === "ONE_TIME"}
                                                onChange={(e) => setExecutionType(e.target.value)}
                                              />
                                              <Form.Check
                                                type="radio"
                                                id="execution-recurring"
                                                label="Recurring Schedule"
                                                name="executionType"
                                                value="RECURRING"
                                                checked={executionType === "RECURRING"}
                                                onChange={(e) => setExecutionType(e.target.value)}
                                              />
                                            </div>
                                          </Form.Group>
                                        </Col>
                                      </Row>

                                      {/* One Time Execution Fields */}
                                      {executionType === "ONE_TIME" && (
                                        <Row>
                                          <Col md={6}>
                                            <Form.Group className="mb-3">
                                              <Form.Label className="fs-12 text-616161">
                                                Start Date <span className="text-danger">*</span>
                                              </Form.Label>
                                              <div
                                                className="d-flex align-items-center justify-content-between"
                                                style={{
                                                  border: "1px solid #EAECEE",
                                                  borderRadius: "8px",
                                                  position: "relative",
                                                }}
                                              >
                                                <DatePicker
                                                  selected={scheduleStartDate}
                                                  onChange={(date) => setScheduleStartDate(date)}
                                                  className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                                  placeholderText="Start Date"
                                                  minDate={new Date()}
                                                  dateFormat="MMM dd, yyyy"
                                                  showMonthDropdown
                                                  showYearDropdown
                                                  dropdownMode="select"
                                                  isClearable={false}
                                                />
                                                {/* <div
                                                  className="border-0 bg-transparent fs-12 d-flex align-items-center pe-2"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => setScheduleStartDate(null)}
                                                  title="Clear date"
                                                >
                                                  <FaCalendarAlt
                                                    className={scheduleStartDate ? "text-danger" : ""}
                                                    style={{
                                                      fontSize: "14px",
                                                      marginLeft: "-18px",
                                                    }}
                                                  />
                                                </div> */}
                                              </div>
                                            </Form.Group>
                                          </Col>
                                          <Col md={6}>
                                            <Form.Group className="mb-3">
                                              <Form.Label className="fs-12">
                                                Time <span className="text-danger">*</span>
                                              </Form.Label>
                                              <Form.Control
                                                type="time"
                                                value={scheduleTime}
                                                onChange={(e) => setScheduleTime(e.target.value)}
                                              />
                                            </Form.Group>
                                          </Col>
                                        </Row>
                                      )}

                                      {/* Recurring Schedule Fields */}
                                      {executionType === "RECURRING" && (
                                        <>
                                          <Row>
                                            <Col md={6}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">
                                                  Frequency <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Select
                                                  value={scheduleFrequency}
                                                  onChange={(e) => setScheduleFrequency(e.target.value)}
                                                >
                                                  <option value="">Select frequency</option>
                                                  <option value="DAILY">Daily</option>
                                                  <option value="WEEKLY">Weekly</option>
                                                  <option value="MONTHLY">Monthly</option>
                                                  <option value="YEARLY">Yearly</option>
                                                </Form.Select>
                                              </Form.Group>
                                            </Col>
                                          </Row>

                                          {/* Daily Schedule Fields */}
                                          {scheduleFrequency === "DAILY" && (
                                            <Row>
                                              <Col md={6}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label className="fs-12 text-616161">
                                                    Start Date <span className="text-danger">*</span>
                                                  </Form.Label>
                                                  <div
                                                    className="d-flex align-items-center justify-content-between"
                                                    style={{
                                                      border: "1px solid #EAECEE",
                                                      borderRadius: "8px",
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <DatePicker
                                                      selected={scheduleStartDate}
                                                      onChange={(date) => setScheduleStartDate(date)}
                                                      className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                                      placeholderText="Select start date"
                                                      minDate={new Date()}
                                                      dateFormat="MMM dd, yyyy"
                                                      showMonthDropdown
                                                      showYearDropdown
                                                      dropdownMode="select"
                                                      isClearable={false}
                                                    />
                                                    {/* <div
                                                      className="border-0 bg-transparent fs-12 d-flex align-items-center pe-2"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => setScheduleStartDate(null)}
                                                      title="Clear date"
                                                    >
                                                      <FaCalendarAlt
                                                        className={scheduleStartDate ? "text-danger" : ""}
                                                        style={{
                                                          fontSize: "14px",
                                                          marginLeft: "-18px",
                                                        }}
                                                      />
                                                    </div> */}
                                                  </div>
                                                </Form.Group>
                                              </Col>
                                              <Col md={6}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label className="fs-12">
                                                    Time <span className="text-danger">*</span>
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="time"
                                                    value={scheduleTime}
                                                    onChange={(e) => setScheduleTime(e.target.value)}
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                          )}

                                          {/* Weekly Schedule Fields */}
                                          {scheduleFrequency === "WEEKLY" && (
                                            <Row>
                                              <Col md={4}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label className="fs-12 text-616161">
                                                    Start Date <span className="text-danger">*</span>
                                                  </Form.Label>
                                                  <div
                                                    className="d-flex align-items-center justify-content-between"
                                                    style={{
                                                      border: "1px solid #EAECEE",
                                                      borderRadius: "8px",
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <DatePicker
                                                      selected={scheduleStartDate}
                                                      onChange={(date) => setScheduleStartDate(date)}
                                                      className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                                      placeholderText="Select start date"
                                                      minDate={new Date()}
                                                      dateFormat="MMM dd, yyyy"
                                                      showMonthDropdown
                                                      showYearDropdown
                                                      dropdownMode="select"
                                                      isClearable={false}
                                                    />
                                                    {/* <div
                                                      className="border-0 bg-transparent fs-12 d-flex align-items-center pe-2"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => setScheduleStartDate(null)}
                                                      title="Clear date"
                                                    >
                                                      <FaCalendarAlt
                                                        className={scheduleStartDate ? "text-danger" : ""}
                                                        style={{
                                                          fontSize: "14px",
                                                          marginLeft: "-18px",
                                                        }}
                                                      />
                                                    </div> */}
                                                  </div>
                                                </Form.Group>
                                              </Col>
                                              <Col md={4}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label className="fs-12">
                                                    Time <span className="text-danger">*</span>
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="time"
                                                    value={scheduleTime}
                                                    onChange={(e) => setScheduleTime(e.target.value)}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={4}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label className="fs-12">
                                                    Day of Week <span className="text-danger">*</span>
                                                  </Form.Label>
                                                  <Form.Select
                                                    value={scheduleDayOfWeek}
                                                    onChange={(e) => setScheduleDayOfWeek(e.target.value)}
                                                  >
                                                    <option value="">Select day</option>
                                                    <option value="MON">Monday</option>
                                                    <option value="TUE">Tuesday</option>
                                                    <option value="WED">Wednesday</option>
                                                    <option value="THU">Thursday</option>
                                                    <option value="FRI">Friday</option>
                                                    <option value="SAT">Saturday</option>
                                                    <option value="SUN">Sunday</option>
                                                  </Form.Select>
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                          )}

                                          {/* Monthly Schedule Fields */}
                                          {scheduleFrequency === "MONTHLY" && (
                                            <Row>
                                              <Col md={4}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label className="fs-12 text-616161">
                                                    Start Date <span className="text-danger">*</span>
                                                  </Form.Label>
                                                  <div
                                                    className="d-flex align-items-center justify-content-between"
                                                    style={{
                                                      border: "1px solid #EAECEE",
                                                      borderRadius: "8px",
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <DatePicker
                                                      selected={scheduleStartDate}
                                                      onChange={(date) => setScheduleStartDate(date)}
                                                      className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                                      placeholderText="Select start date"
                                                      minDate={new Date()}
                                                      dateFormat="MMM dd, yyyy"
                                                      showMonthDropdown
                                                      showYearDropdown
                                                      dropdownMode="select"
                                                      isClearable={false}
                                                    />
                                                    {/* <div
                                                      className="border-0 bg-transparent fs-12 d-flex align-items-center pe-2"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => setScheduleStartDate(null)}
                                                      title="Clear date"
                                                    >
                                                      <FaCalendarAlt
                                                        className={scheduleStartDate ? "text-danger" : ""}
                                                        style={{
                                                          fontSize: "14px",
                                                          marginLeft: "-18px",
                                                        }}
                                                      />
                                                    </div> */}
                                                  </div>
                                                </Form.Group>
                                              </Col>
                                              <Col md={4}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label className="fs-12">
                                                    Time <span className="text-danger">*</span>
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="time"
                                                    value={scheduleTime}
                                                    onChange={(e) => setScheduleTime(e.target.value)}
                                                  />
                                                </Form.Group>
                                              </Col>
                                              <Col md={4}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label className="fs-12">
                                                    Date of Month <span className="text-danger">*</span>
                                                  </Form.Label>
                                                  <Form.Select
                                                    value={scheduleDayOfMonth}
                                                    onChange={(e) => setScheduleDayOfMonth(e.target.value)}
                                                  >
                                                    <option value="">Select date</option>
                                                    {[...Array(31)].map((_, i) => (
                                                      <option key={i + 1} value={i + 1}>
                                                        {i + 1}
                                                      </option>
                                                    ))}
                                                  </Form.Select>
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                          )}

                                          {/* Yearly Schedule Fields */}
                                          {scheduleFrequency === "YEARLY" && (
                                            <Row>
                                              <Col md={6}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label className="fs-12 text-616161">
                                                    Start Date (Month & Day) <span className="text-danger">*</span>
                                                  </Form.Label>
                                                  <div
                                                    className="d-flex align-items-center justify-content-between"
                                                    style={{
                                                      border: "1px solid #EAECEE",
                                                      borderRadius: "8px",
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <DatePicker
                                                      selected={scheduleStartDate}
                                                      onChange={(date) => setScheduleStartDate(date)}
                                                      className="form-control border-0 search-fields mr-sm-2 GeneralSansMedium fw-500"
                                                      placeholderText="Select month and day"
                                                      minDate={new Date()}
                                                      dateFormat="MMM dd"
                                                      showMonthDropdown
                                                      isClearable={false}
                                                    />
                                                    {/* <div
                                                      className="border-0 bg-transparent fs-12 d-flex align-items-center pe-2"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => setScheduleStartDate(null)}
                                                      title="Clear date"
                                                    >
                                                      <FaCalendarAlt
                                                        className={scheduleStartDate ? "text-danger" : ""}
                                                        style={{
                                                          fontSize: "14px",
                                                          marginLeft: "-18px",
                                                        }}
                                                      />
                                                    </div> */}
                                                  </div>
                                                  <Form.Text className="text-muted">
                                                    Schedule will run on this date every year
                                                  </Form.Text>
                                                </Form.Group>
                                              </Col>
                                              <Col md={6}>
                                                <Form.Group className="mb-3">
                                                  <Form.Label className="fs-12">
                                                    Time <span className="text-danger">*</span>
                                                  </Form.Label>
                                                  <Form.Control
                                                    type="time"
                                                    value={scheduleTime}
                                                    onChange={(e) => setScheduleTime(e.target.value)}
                                                  />
                                                </Form.Group>
                                              </Col>
                                            </Row>
                                          )}
                                        </>
                                      )}

                                      {/* Report Type Selection */}
                                      <Row>
                                        <Col md={12}>
                                          <hr className="my-4" />
                                          <h6 className="mb-3 fw-600 text-101828">
                                            Report Configuration
                                          </h6>
                                        </Col>
                                      </Row>

                                      <Row>
                                        <Col md={6}>
                                          <Form.Group className="mb-3">
                                            <Form.Label className="fs-12">
                                              Report Type <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Select
                                              value={selectedReportType}
                                              onChange={(e) => setSelectedReportType(e.target.value)}
                                            >
                                              <option value="">Select report type</option>
                                              <option value="clickData">Click Data Report</option>
                                              <option value="urlHistory">URL Shortening Report</option>
                                              <option value="creditHistory">Credit Record Report</option>
                                              <option value="creditConsumption">Credit Consumption Report</option>
                                            </Form.Select>
                                          </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                          <Form.Group className="mb-3">
                                            <Form.Label className="fs-12">
                                              Directory Path
                                            </Form.Label>
                                            <Form.Control
                                              type="text"
                                              placeholder="/exports or leave empty for root"
                                              value={scheduleDirectoryPath}
                                              onChange={(e) => setScheduleDirectoryPath(e.target.value)}
                                            />
                                            <Form.Text className="text-muted fs-11">
                                              Specify the directory path where files will be stored (optional)
                                            </Form.Text>
                                          </Form.Group>
                                        </Col>
                                      </Row>

                                      {/* Dynamic Filters Based on Report Type */}
                                      {selectedReportType === "clickData" && (
                                        <>
                                          <Row>
                                            <Col md={12}>
                                              <h6 className="mb-3 fw-500 fs-14 text-616161">
                                                Click Data Filters
                                              </h6>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col md={6}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">Campaign Name</Form.Label>
                                                <Form.Control
                                                  type="text"
                                                  placeholder="Enter campaign name"
                                                  value={scheduleClickDataFilters.campaignName}
                                                  onChange={(e) => setScheduleClickDataFilters(prev => ({
                                                    ...prev,
                                                    campaignName: e.target.value
                                                  }))}
                                                />
                                              </Form.Group>
                                            </Col>
                                          </Row>
                                          {executionType === "ONE_TIME" && (
                                          <Row>
                                            <Col md={6}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">Start Date</Form.Label>
                                                <DatePicker
                                                  selected={scheduleClickDataFilters.startDate}
                                                  onChange={(date) => setScheduleClickDataFilters(prev => ({
                                                    ...prev,
                                                    startDate: date
                                                  }))}
                                                  className="form-control"
                                                  placeholderText="Start Date"
                                                  dateFormat="MMM dd, yyyy"
                                                   showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                                  maxDate={scheduleClickDataFilters.endDate || new Date()}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">End Date</Form.Label>
                                                <DatePicker
                                                  selected={scheduleClickDataFilters.endDate}
                                                  onChange={(date) => setScheduleClickDataFilters(prev => ({
                                                    ...prev,
                                                    endDate: date
                                                  }))}
                                                  className="form-control"
                                                  placeholderText="End Date"
                                                  dateFormat="MMM dd, yyyy"
                                                   showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                                  minDate={scheduleClickDataFilters.startDate}
                                                  maxDate={new Date()}
                                                />
                                              </Form.Group>
                                            </Col>
                                          </Row>
                                          )}
                                        </>
                                      )}

                                      {selectedReportType === "urlHistory" && (
                                        <>
                                          <Row>
                                            <Col md={12}>
                                              <h6 className="mb-3 fw-500 fs-14 text-616161">
                                                URL Shortening Filters
                                              </h6>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col md={4}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">Campaign Name</Form.Label>
                                                <Form.Control
                                                  type="text"
                                                  placeholder="Enter campaign name"
                                                  value={scheduleUrlHistoryFilters.campaignName}
                                                  onChange={(e) => setScheduleUrlHistoryFilters(prev => ({
                                                    ...prev,
                                                    campaignName: e.target.value
                                                  }))}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">Sender ID</Form.Label>
                                                <Form.Control
                                                  type="text"
                                                  placeholder="Enter sender ID"
                                                  value={scheduleUrlHistoryFilters.senderId}
                                                  onChange={(e) => setScheduleUrlHistoryFilters(prev => ({
                                                    ...prev,
                                                    senderId: e.target.value
                                                  }))}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">Individual ID</Form.Label>
                                                <Form.Control
                                                  type="text"
                                                  placeholder="Enter individual ID"
                                                  value={scheduleUrlHistoryFilters.indivId}
                                                  onChange={(e) => setScheduleUrlHistoryFilters(prev => ({
                                                    ...prev,
                                                    indivId: e.target.value
                                                  }))}
                                                />
                                              </Form.Group>
                                            </Col>
                                          </Row>
                                          {executionType === "ONE_TIME" && (
                                          <Row>
                                            <Col md={6}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">Start Date</Form.Label>
                                                <DatePicker
                                                  selected={scheduleUrlHistoryFilters.startDate}
                                                  onChange={(date) => setScheduleUrlHistoryFilters(prev => ({
                                                    ...prev,
                                                    startDate: date
                                                  }))}
                                                  className="form-control"
                                                  placeholderText="Start Date"
                                                  dateFormat="MMM dd, yyyy"
                                                   showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                                  maxDate={scheduleUrlHistoryFilters.endDate || new Date()}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">End Date</Form.Label>
                                                <DatePicker
                                                  selected={scheduleUrlHistoryFilters.endDate}
                                                  onChange={(date) => setScheduleUrlHistoryFilters(prev => ({
                                                    ...prev,
                                                    endDate: date
                                                  }))}
                                                  className="form-control"
                                                  placeholderText="End Date"
                                                  dateFormat="MMM dd, yyyy"
                                                   showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                                  minDate={scheduleUrlHistoryFilters.startDate}
                                                  maxDate={new Date()}
                                                />
                                              </Form.Group>
                                            </Col>
                                          </Row>
                                          )}
                                        </>
                                      )}

                                      {selectedReportType === "creditHistory" && (
                                        <>
                                          <Row>
                                            <Col md={12}>
                                              <h6 className="mb-3 fw-500 fs-14 text-616161">
                                                Credit Record Filters
                                              </h6>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col md={6}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">Transaction Type</Form.Label>
                                                <Form.Select
                                                  value={scheduleCreditHistoryFilters.transactionType}
                                                  onChange={(e) => setScheduleCreditHistoryFilters(prev => ({
                                                    ...prev,
                                                    transactionType: e.target.value
                                                  }))}
                                                >
                                                  <option value="">All</option>
                                                  <option value="CREDIT">Credit</option>
                                                  <option value="DEBIT">Debit</option>
                                                </Form.Select>
                                              </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">Credit Type</Form.Label>
                                                <Form.Select
                                                  value={scheduleCreditHistoryFilters.creditType}
                                                  onChange={(e) => setScheduleCreditHistoryFilters(prev => ({
                                                    ...prev,
                                                    creditType: e.target.value
                                                  }))}
                                                >
                                                  <option value="">All</option>
                                                  <option value="tracking">Tracking</option>
                                                  <option value="shortning">Shortning</option>
                                                </Form.Select>
                                              </Form.Group>
                                            </Col>
                                          </Row>
                                          {executionType === "ONE_TIME" && (
                                          <Row>
                                            <Col md={6}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">Start Date</Form.Label>
                                                <DatePicker
                                                  selected={scheduleCreditHistoryFilters.startDate}
                                                  onChange={(date) => setScheduleCreditHistoryFilters(prev => ({
                                                    ...prev,
                                                    startDate: date
                                                  }))}
                                                  className="form-control"
                                                  placeholderText="Start Date"
                                                  dateFormat="MMM dd, yyyy"
                                                   showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                                  maxDate={scheduleCreditHistoryFilters.endDate || new Date()}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">End Date</Form.Label>
                                                <DatePicker
                                                  selected={scheduleCreditHistoryFilters.endDate}
                                                  onChange={(date) => setScheduleCreditHistoryFilters(prev => ({
                                                    ...prev,
                                                    endDate: date
                                                  }))}
                                                  className="form-control"
                                                  placeholderText="End Date"
                                                  dateFormat="MMM dd, yyyy"
                                                   showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                                  minDate={scheduleCreditHistoryFilters.startDate}
                                                  maxDate={new Date()}
                                                />
                                              </Form.Group>
                                            </Col>
                                          </Row>
                                          )}
                                        </>
                                      )}

                                      {selectedReportType === "creditConsumption" && (
                                        <>
                                          <Row>
                                            <Col md={12}>
                                              <h6 className="mb-3 fw-500 fs-14 text-616161">
                                                Credit Consumption Filters
                                              </h6>
                                            </Col>
                                          </Row>
                                          <Row>
                                            <Col md={6}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">Credit Type</Form.Label>
                                                <Form.Select
                                                  value={scheduleCreditConsumptionFilters.creditType}
                                                  onChange={(e) => setScheduleCreditConsumptionFilters(prev => ({
                                                    ...prev,
                                                    creditType: e.target.value
                                                  }))}
                                                >
                                                  <option value="">All</option>
                                                  <option value="URL">URL</option>
                                                  <option value="QR">QR</option>
                                                </Form.Select>
                                              </Form.Group>
                                            </Col>
                                          </Row>
                                          {executionType === "ONE_TIME" && (
                                          <Row>
                                            <Col md={6}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">Start Date</Form.Label>
                                                <DatePicker
                                                  selected={scheduleCreditConsumptionFilters.startDate}
                                                  onChange={(date) => setScheduleCreditConsumptionFilters(prev => ({
                                                    ...prev,
                                                    startDate: date
                                                  }))}
                                                  className="form-control"
                                                  placeholderText="Start Date"
                                                  dateFormat="MMM dd, yyyy"
                                                   showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                                  maxDate={scheduleCreditConsumptionFilters.endDate || new Date()}
                                                />
                                              </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                              <Form.Group className="mb-3">
                                                <Form.Label className="fs-12">End Date</Form.Label>
                                                <DatePicker
                                                  selected={scheduleCreditConsumptionFilters.endDate}
                                                  onChange={(date) => setScheduleCreditConsumptionFilters(prev => ({
                                                    ...prev,
                                                    endDate: date
                                                  }))}
                                                  className="form-control"
                                                  placeholderText="End Date"
                                                  dateFormat="MMM dd, yyyy"
                                                   showMonthDropdown
                                              showYearDropdown
                                              dropdownMode="select"
                                                  minDate={scheduleCreditConsumptionFilters.startDate}
                                                  maxDate={new Date()}
                                                />
                                              </Form.Group>
                                            </Col>
                                          </Row>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                  </>
                                  )}
                                </Card.Body>
                              </Card>
 {selectedConfigUsername && (
                              <div className="d-flex justify-content-end gap-2 mt-4">
                                {!showScheduleFields ? (
                                  // Update and Test Connection Buttons (only when not editing schedule)
                                  <>
                                    <Button
                                      variant="success"
                                      onClick={handleSftpTestConnection}
                                      disabled={sftpTesting || !canTestConnection}
                                      className="d-flex align-items-center gap-2 br-radius-8"
                                      style={{ padding: "9px 15px" }}
                                    >
                                      {sftpTesting ? (
                                        <>
                                          <Spinner size="sm" className="me-2" />
                                          <span className="fw-400 fs-12">Testing...</span>
                                        </>
                                      ) : (
                                        <span className="fw-400 fs-12">Test Connection</span>
                                      )}
                                    </Button>
                                  </>
                                ) : (
                                  // Finish/Update Button (after test success and schedule fields shown)
                                  <>
                                    {isEditingSchedule && (
                                      <Button
                                        variant="light"
                                        onClick={() => {
                                          setIsEditingSchedule(false);
                                          setScheduleToEdit(null);
                                          setSftpFormData(prev => ({
                                            ...prev,
                                            schedule: "",
                                            time: "",
                                            scheduleDay: "",
                                            dayOfWeek: "",
                                            yearlyMonth: "",
                                            yearlyDay: "",
                                          }));
                                          setShowScheduleFields(false);
                                          setSftpTestSuccess(false);
                                        }}
                                        className="d-flex align-items-center gap-2 br-radius-8 bg-white"
                                        style={{ padding: "9px 15px" }}
                                      >
                                        <span className="fw-400 fs-12">Cancel</span>
                                      </Button>
                                    )}
                                    <Button
                                      variant="success"
                                      onClick={handleSftpFinish}
                                      disabled={sftpSubmitting || !isSftpScheduleFormValid()}
                                      className="d-flex align-items-center gap-2 br-radius-8"
                                      style={{ padding: "9px 15px" }}
                                    >
                                      {sftpSubmitting ? (
                                        <>
                                          <Spinner size="sm" className="me-2" />
                                          <span className="fw-400 fs-12">
                                            {isEditingSchedule ? "Updating..." : "Creating Schedule..."}
                                          </span>
                                        </>
                                      ) : (
                                        <span className="fw-400 fs-12">
                                          {isEditingSchedule ? "Update Schedule" : "Finish"}
                                        </span>
                                      )}
                                    </Button>
                                  </>
                                )}
                              </div>
                              )}
                               </>
                               )}
                                  </div>
                                </Tab>

                                <Tab eventKey="history" title="History">
                                  <div className="p-4">
                              {/* Schedules Table - Moved to History Tab */}
                              {hasExistingConfig ? (
                                <div>
                                  <h5 className="mb-3 fw-600 fs-16 text-101828">
                                    Export Schedules
                                  </h5>
                                  
                                  {schedulesLoading ? (
                                    <div className="text-center py-4">
                                      <Spinner animation="border" variant="success" />
                                      <p className="mt-3 text-muted">Loading schedules...</p>
                                    </div>
                                  ) : schedules.length === 0 ? (
                                    <div className="text-center py-4">
                                      <Image src={noRecordFound} width={100} className="mb-3" />
                                      <h5 className="mb-1 fs-14 fw-600">No Schedules Found</h5>
                                      <p className="text-muted">Create a schedule by testing the connection first</p>
                                    </div>
                                  ) : (
                                    <>
                                      {/* Search and Filter Controls */}
                                      <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div className="d-flex align-items-center gap-3">
                                          <div className="position-relative">
                                            <input
                                              type="text"
                                              placeholder="Search schedules..."
                                              className="form-control"
                                              value={scheduleSearchTerm}
                                              onChange={(e) => setScheduleSearchTerm(e.target.value)}
                                              style={{ width: "250px", paddingRight: "40px" }}
                                            />
                                            <Image
                                              style={{ right: "15px", top: "12px" }}
                                              width={15}
                                              className="position-absolute"
                                              src={searchIcon}
                                            />
                                          </div>
                                          
                                          <Dropdown>
                                            <Dropdown.Toggle
                                              variant="light"
                                              className="bg-white cus-dropdown-toggle-show"
                                              style={{ borderRadius: "8px", borderColor: "#C2C2C2" }}
                                            >
                                              <IoFilterOutline className="me-2" />
                                              {scheduleFrequencyFilter === "ALL"
                                                ? "All Frequencies"
                                                : scheduleFrequencyFilter === "DAILY"
                                                ? "Daily"
                                                : scheduleFrequencyFilter === "WEEKLY"
                                                ? "Weekly"
                                                : scheduleFrequencyFilter === "MONTHLY"
                                                ? "Monthly"
                                                : scheduleFrequencyFilter === "YEARLY"
                                                ? "Yearly"
                                                : scheduleFrequencyFilter === "ONCE"
                                                ? "One Time"
                                                : "Filter"}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                              <Dropdown.Item 
                                                active={scheduleFrequencyFilter === "ALL"}
                                                onClick={() => setScheduleFrequencyFilter("ALL")}
                                              >
                                                All Frequencies
                                              </Dropdown.Item>
                                              <Dropdown.Item 
                                                active={scheduleFrequencyFilter === "ONCE"}
                                                onClick={() => setScheduleFrequencyFilter("ONCE")}
                                              >
                                                One Time
                                              </Dropdown.Item>
                                              <Dropdown.Item 
                                                active={scheduleFrequencyFilter === "DAILY"}
                                                onClick={() => setScheduleFrequencyFilter("DAILY")}
                                              >
                                                Daily
                                              </Dropdown.Item>
                                              <Dropdown.Item 
                                                active={scheduleFrequencyFilter === "WEEKLY"}
                                                onClick={() => setScheduleFrequencyFilter("WEEKLY")}
                                              >
                                                Weekly
                                              </Dropdown.Item>
                                              <Dropdown.Item 
                                                active={scheduleFrequencyFilter === "MONTHLY"}
                                                onClick={() => setScheduleFrequencyFilter("MONTHLY")}
                                              >
                                                Monthly
                                              </Dropdown.Item>
                                              <Dropdown.Item 
                                                active={scheduleFrequencyFilter === "YEARLY"}
                                                onClick={() => setScheduleFrequencyFilter("YEARLY")}
                                              >
                                                Yearly
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>

                                          {(scheduleFrequencyFilter !== "ALL" || scheduleSearchTerm) && (
                                            <Button 
                                              variant="light" 
                                              className="bg-white"
                                              style={{ padding: "10px 10px", borderRadius: "8px" }}
                                              onClick={() => {
                                                setScheduleFrequencyFilter("ALL");
                                                setScheduleSearchTerm("");
                                              }}
                                              title="Clear Filters"
                                            >
                                              <FcClearFilters className="fs-16" />
                                            </Button>
                                          )}
                                        </div>
                                      </div>

                                      <div className="table-responsive">
                                        <Table hover className="mb-0 table-hover-border" style={{ minWidth: '900px' }}>
                                        <thead>
                                          <tr>
                                            {/* <th>Sr No.</th> */}
                                            <th 
                                              onClick={() => handleScheduleSort('frequency')}
                                              style={{ cursor: 'pointer', userSelect: 'none', width: '20%' }}
                                            >
                                              <div className="d-flex justify-content-between align-items-center">
                                                <span>Schedule Info</span>
                                                <span>
                                                  {scheduleSortField === 'frequency' ? (
                                                    scheduleSortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />
                                                  ) : (
                                                    <FaSort className="text-muted" />
                                                  )}
                                                </span>
                                              </div>
                                            </th>
                                            <th 
                                              onClick={() => handleScheduleSort('reportType')}
                                              style={{ cursor: 'pointer', userSelect: 'none', width: '20%' }}
                                            >
                                              Report Type{' '}
                                              {scheduleSortField === 'reportType' ? (
                                                scheduleSortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />
                                              ) : (
                                                <FaSort className="text-muted" />
                                              )}
                                            </th>
                                            <th 
                                              onClick={() => handleScheduleSort('isActive')}
                                              style={{ cursor: 'pointer', userSelect: 'none', width: '15%' }}
                                            >
                                              Status{' '}
                                              {scheduleSortField === 'isActive' ? (
                                                scheduleSortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />
                                              ) : (
                                                <FaSort className="text-muted" />
                                              )}
                                            </th>
                                            <th 
                                              onClick={() => handleScheduleSort('lastExecutionTime')}
                                              style={{ cursor: 'pointer', userSelect: 'none', width: '25%' }}
                                            >
                                              Execution Status{' '}
                                              {scheduleSortField === 'lastExecutionTime' ? (
                                                scheduleSortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />
                                              ) : (
                                                <FaSort className="text-muted" />
                                              )}
                                            </th>
                                            <th style={{ width: '10%' }}>History</th>
                                            <th style={{ width: '10%' }}>Actions</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {getFilteredAndSortedSchedules().length === 0 ? (
                                            <tr>
                                              <td colSpan="6" className="text-center py-4">
                                                <Image src={noRecordFound} width={80} className="mb-2" />
                                                <p className="mb-0 text-muted fs-14">
                                                  {scheduleSearchTerm || scheduleFrequencyFilter !== 'ALL'
                                                    ? 'No schedules match your search criteria'
                                                    : 'No schedules found'}
                                                </p>
                                              </td>
                                            </tr>
                                          ) : (
                                            getFilteredAndSortedSchedules().map((schedule, index) => (
                                              <tr key={schedule.id}>
                                                {/* <td>{index + 1}</td> */}
                                                <td>
                                                  <div className="fw-600 fs-12 text-dark">
                                                    {schedule.frequency === 'ONCE' ? 'One Time' : schedule.frequency}
                                                    {schedule.frequency !== 'ONCE' && (
                                                      <span className="ms-1 text-muted fw-400">
                                                        ({schedule.frequency === 'MONTHLY' && schedule.scheduleDay ? `Day ${schedule.scheduleDay}` 
                                                          : schedule.frequency === 'WEEKLY' && schedule.dayOfWeek ? schedule.dayOfWeek 
                                                          : schedule.frequency === 'YEARLY' && schedule.yearlyDate ? schedule.yearlyDate 
                                                          : '-'})
                                                      </span>
                                                    )}
                                                  </div>
                                                  <div className="text-muted fs-11 mt-1">
                                                    <FaCalendarAlt className="me-1" style={{ fontSize: '10px' }} />
                                                    At {schedule.scheduledTime || 'N/A'}
                                                  </div>
                                                </td>
                                                <td>
                                                  <span className="badge bg-light text-dark fs-11">
                                                    {schedule.reportType === 'CLICK_DATA' ? 'Click Data' 
                                                    : schedule.reportType === 'URL_SHORTENING' ? 'URL Shortening'
                                                    : schedule.reportType === 'CREDIT_HISTORY' ? 'Credit Record'
                                                    : schedule.reportType === 'CREDIT_CONSUMPTION' ? 'Credit Consumption'
                                                    : schedule.reportType || 'N/A'}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span
                                                    className={`badge badge-before position-relative ps-3 bg-${
                                                      schedule.isActive ? "success" : "danger"
                                                    }`}
                                                  >
                                                    {schedule.isActive ? "Active" : "Inactive"}
                                                  </span>
                                                </td>
                                                <td>
                                                  <div className="fs-11">
                                                    <span className="text-muted">Last: </span>
                                                    <span className="fw-500">{schedule.lastExecutionTime ? new Date(schedule.lastExecutionTime).toLocaleString() : 'Never'}</span>
                                                  </div>
                                                  <div className="fs-11 mt-1">
                                                    <span className="text-muted">Next: </span>
                                                    <span className="fw-500 text-success">
                                                      {(() => {
                                                        const nextExec = calculateNextExecutionTime(schedule);
                                                        return nextExec ? nextExec.toLocaleString() : '-';
                                                      })()}
                                                    </span>
                                                  </div>
                                                </td>
                                                <td>
                                                  <Button
                                                    variant="link"
                                                    onClick={() => handleViewScheduleHistory(schedule)}
                                                    className="p-0 text-success"
                                                    title="View History"
                                                  >
                                                    <FaArrowRight 
                                                      className="fs-16" 
                                                      style={{ transform: 'rotate(-45deg)' }}
                                                    />
                                                  </Button>
                                                </td>
                                                <td>
                                                  {executingScheduleId === schedule.id ? (
                                                    <div className="text-center">
                                                      <Spinner 
                                                        animation="border" 
                                                        size="sm" 
                                                        variant="success"
                                                        style={{ width: '16px', height: '16px' }}
                                                      />
                                                    </div>
                                                  ) : (
                                                    <Dropdown className="cust-drop">
                                                      <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                        <FaEllipsisV className="text-A8B0B9 fs-12" />
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu>
                                                        <Dropdown.Item
                                                          onClick={() => handleExecuteScheduleNow(schedule)}
                                                          href="#"
                                                          className="fs-12 pt-2 pb-2"
                                                        >
                                                          <FaCalendarAlt className="align-middle fs-12 me-1" /> Run Now
                                                        </Dropdown.Item>
                                                        {/* <Dropdown.Item
                                                          onClick={() => handleEditScheduleClick(schedule)}
                                                          href="#"
                                                          className="fs-12 pt-2 pb-2"
                                                        >
                                                          <GrEdit className="align-middle fs-12 me-1" /> Edit
                                                        </Dropdown.Item> */}
                                                        <Dropdown.Item
                                                          onClick={() => handleDeleteScheduleClick(schedule)}
                                                          className="fs-12 pt-2 pb-2"
                                                          href="#"
                                                        >
                                                          <RiDeleteBin5Line className="align-middle fs-14 me-1" /> Delete
                                                        </Dropdown.Item>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  )}
                                                </td>
                                              </tr>
                                            ))
                                          )}
                                        </tbody>
                                      </Table>
                                    </div>
                                    </>
                                  )}
                                </div>
                              ) : (
                                <div className="text-center py-5">
                                  <Image src={noRecordFound} width={100} className="mb-3" />
                                  <h5 className="mb-1 fs-14 fw-600">No Configuration Found</h5>
                                  <p className="text-muted">Create an SFTP configuration first in the Schedule Export tab</p>
                                </div>
                              )}
                                  </div>
                                </Tab>

                                {/* Schedule History Tab - Only visible when clicking arrow in Export Schedules table */}
                                {showScheduleHistoryTab && (
                                <Tab eventKey="scheduleHistory" title="Schedule History">
                                  <div className="p-4">
                                    {selectedScheduleForHistory ? (
                                      <>
                                        <div className="d-flex justify-content-between align-items-center mb-4">
                                          <div>
                                            <h5 className="mb-1 fw-600 fs-16 text-101828">
                                              Export History
                                            </h5>
                                            <p className="mb-0 text-muted fs-12">
                                              Schedule: <span className="fw-600">{selectedScheduleForHistory.frequency}</span> at {selectedScheduleForHistory.scheduledTime}
                                            </p>
                                          </div>
                                          <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={() => {
                                              setSelectedScheduleForHistory(null);
                                              setShowScheduleHistoryTab(false);
                                              setSftpSubTab("history");
                                            }}
                                            className="br-radius-8"
                                          >
                                            Back to Schedules
                                          </Button>
                                        </div>

                                        {scheduleHistoryLoading ? (
                                          <div className="text-center py-5">
                                            <Spinner animation="border" variant="success" />
                                            <p className="mt-3 text-muted">Loading export history...</p>
                                          </div>
                                        ) : scheduleHistory.length === 0 && !historySearchTerm ? (
                                          <div className="text-center py-5">
                                            <Image src={noRecordFound} width={100} className="mb-3" />
                                            <h5 className="mb-1 fs-14 fw-600">No History Found</h5>
                                            <p className="text-muted">This schedule has not been executed yet</p>
                                          </div>
                                        ) : (
                                          <>
                                            {/* Search Control */}
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                              <div className="d-flex align-items-center gap-3">
                                                <div className="position-relative">
                                                  <input
                                                    type="text"
                                                    placeholder="Search history..."
                                                    className="form-control"
                                                    value={historySearchTerm}
                                                    onChange={(e) => setHistorySearchTerm(e.target.value)}
                                                    style={{ width: "250px", paddingRight: "40px" }}
                                                  />
                                                  <Image
                                                    style={{ right: "15px", top: "12px" }}
                                                    width={15}
                                                    className="position-absolute"
                                                    src={searchIcon}
                                                  />
                                                </div>
                                                
                                                {historySearchTerm && (
                                                  <Button 
                                                    variant="light" 
                                                    className="bg-white"
                                                    style={{ padding: "10px 10px", borderRadius: "8px" }}
                                                    onClick={() => setHistorySearchTerm("")}
                                                    title="Clear Search"
                                                  >
                                                    <FcClearFilters className="fs-16" />
                                                  </Button>
                                                )}
                                              </div>
                                            </div>

                                            <Table responsive hover className="mb-0 table-hover-border">
                                              <thead>
                                                <tr>
                                                  <th>Sr No.</th>
                                                  <th 
                                                    onClick={() => handleHistorySort('exportedAt')}
                                                    style={{ cursor: 'pointer', userSelect: 'none' }}
                                                  >
                                                    Exported At{' '}
                                                    {historySortField === 'exportedAt' ? (
                                                      historySortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />
                                                    ) : (
                                                      <FaSort className="text-muted" />
                                                    )}
                                                  </th>
                                                  <th 
                                                    onClick={() => handleHistorySort('status')}
                                                    style={{ cursor: 'pointer', userSelect: 'none' }}
                                                  >
                                                    Status{' '}
                                                    {historySortField === 'status' ? (
                                                      historySortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />
                                                    ) : (
                                                      <FaSort className="text-muted" />
                                                    )}
                                                  </th>
                                                  <th 
                                                    onClick={() => handleHistorySort('fileName')}
                                                    style={{ cursor: 'pointer', userSelect: 'none' }}
                                                  >
                                                    File Name{' '}
                                                    {historySortField === 'fileName' ? (
                                                      historySortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />
                                                    ) : (
                                                      <FaSort className="text-muted" />
                                                    )}
                                                  </th>
                                                  <th 
                                                    onClick={() => handleHistorySort('fileSizeBytes')}
                                                    style={{ cursor: 'pointer', userSelect: 'none' }}
                                                  >
                                                    File Size{' '}
                                                    {historySortField === 'fileSizeBytes' ? (
                                                      historySortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />
                                                    ) : (
                                                      <FaSort className="text-muted" />
                                                    )}
                                                  </th>
                                                  <th>Error Message</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {getFilteredAndSortedHistory().length === 0 ? (
                                                  <tr>
                                                    <td colSpan="6" className="text-center py-4">
                                                      <Image src={noRecordFound} width={80} className="mb-2" />
                                                      <p className="mb-0 text-muted fs-14">
                                                        {historySearchTerm
                                                          ? 'No history records match your search criteria'
                                                          : 'No history records found'}
                                                      </p>
                                                    </td>
                                                  </tr>
                                                ) : (
                                                  getFilteredAndSortedHistory().map((record, index) => (
                                                    <tr key={record.id || index}>
                                                      <td>{(historyPage * historySize) + index + 1}</td>
                                                      <td>{record.exportedAt ? new Date(record.exportedAt).toLocaleString() : 'N/A'}</td>
                                                      <td>
                                                        <span
                                                          className={`badge badge-before position-relative ps-3 bg-${
                                                            record.status === 'SUCCESS' ? "success" : 
                                                            record.status === 'FAILED' ? "danger" : 
                                                            "warning"
                                                          }`}
                                                        >
                                                          {record.status || 'N/A'}
                                                        </span>
                                                      </td>
                                                      <td>{record.fileName || 'N/A'}</td>
                                                      <td>{formatFileSize(record.fileSizeBytes)}</td>
                                                      <td>
                                                        <span 
                                                          className="text-muted fs-12" 
                                                          title={record.errorMessage}
                                                          style={{
                                                            maxWidth: '200px',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                            display: 'inline-block'
                                                          }}
                                                        >
                                                          {record.errorMessage || '-'}
                                                        </span>
                                                      </td>
                                                    </tr>
                                                  ))
                                                )}
                                              </tbody>
                                            </Table>

                                            {/* Pagination */}
                                            {historyTotalPages > 1 && (
                                              <div className="d-flex justify-content-center mt-4">
                                                <nav>
                                                  <ul className="pagination mb-2">
                                                    <li className={`page-item ${historyPage === 0 ? 'disabled' : ''}`}>
                                                      <button
                                                        className="page-link"
                                                        onClick={() => handleHistoryPageChange(0)}
                                                        disabled={historyPage === 0}
                                                      >
                                                        &laquo;
                                                      </button>
                                                    </li>
                                                    <li className={`page-item ${historyPage === 0 ? 'disabled' : ''}`}>
                                                      <button
                                                        className="page-link"
                                                        onClick={() => handleHistoryPageChange(historyPage - 1)}
                                                        disabled={historyPage === 0}
                                                      >
                                                        &lsaquo;
                                                      </button>
                                                    </li>
                                                    {[...Array(historyTotalPages)].map((_, i) => (
                                                      <li key={i} className={`page-item ${historyPage === i ? 'active' : ''}`}>
                                                        <button
                                                          className="page-link"
                                                          onClick={() => handleHistoryPageChange(i)}
                                                        >
                                                          {i + 1}
                                                        </button>
                                                      </li>
                                                    ))}
                                                    <li className={`page-item ${historyPage === historyTotalPages - 1 ? 'disabled' : ''}`}>
                                                      <button
                                                        className="page-link"
                                                        onClick={() => handleHistoryPageChange(historyPage + 1)}
                                                        disabled={historyPage === historyTotalPages - 1}
                                                      >
                                                        &rsaquo;
                                                      </button>
                                                    </li>
                                                    <li className={`page-item ${historyPage === historyTotalPages - 1 ? 'disabled' : ''}`}>
                                                      <button
                                                        className="page-link"
                                                        onClick={() => handleHistoryPageChange(historyTotalPages - 1)}
                                                        disabled={historyPage === historyTotalPages - 1}
                                                      >
                                                        &raquo;
                                                      </button>
                                                    </li>
                                                  </ul>
                                                </nav>
                                              </div>
                                            )}
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <div className="text-center py-5">
                                        <Image src={noRecordFound} width={100} className="mb-3" />
                                        <h5 className="mb-1 fs-14 fw-600">No Schedule Selected</h5>
                                        <p className="text-muted">Select a schedule from the History tab to view its execution history</p>
                                      </div>
                                    )}
                                  </div>
                                </Tab>
                                )}
                              </Tabs>
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  </Tab>
                  )}

                  {/* Schedule History Tab */}
                  {showHistoryTab && (
                    <Tab eventKey="scheduleHistory" title="Schedule History">
                      <div className="main-container p-0">
                        <Row>
                          <Col lg={12}>
                            <Card className="br-radius-0 card-nostyle">
                              <Card.Header className="bg-white border-0 br-radius-12 rounded-bottom-0 d-flex justify-content-between align-items-center p-3">
                                <div>
                                  <h5 className="mb-1 fw-600 fs-16 text-101828">
                                    Export History
                                  </h5>
                                  {selectedScheduleForHistory && (
                                    <p className="mb-0 text-muted fs-12">
                                      Schedule: <span className="fw-600">{selectedScheduleForHistory.frequency}</span> at {selectedScheduleForHistory.scheduledTime}
                                    </p>
                                  )}
                                </div>
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  onClick={() => {
                                    setActiveTab("sftpDestination");
                                  }}
                                  className="br-radius-8"
                                >
                                  Back to Schedules
                                </Button>
                              </Card.Header>
                              <Card.Body className="p-4">
                                {scheduleHistoryLoading ? (
                                  <div className="text-center py-5">
                                    <Spinner animation="border" variant="success" />
                                    <p className="mt-3 text-muted">Loading export history...</p>
                                  </div>
                                ) : scheduleHistory.length === 0 && !historySearchTerm ? (
                                  <div className="text-center py-5">
                                    <Image src={noRecordFound} width={100} className="mb-3" />
                                    <h5 className="mb-1 fs-14 fw-600">No History Found</h5>
                                    <p className="text-muted">This schedule has not been executed yet</p>
                                  </div>
                                ) : (
                                  <>
                                    {/* Search Control */}
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                      <div className="d-flex align-items-center gap-3">
                                        <div className="position-relative">
                                          <input
                                            type="text"
                                            placeholder="Search history..."
                                            className="form-control"
                                            value={historySearchTerm}
                                            onChange={(e) => setHistorySearchTerm(e.target.value)}
                                            style={{ width: "250px", paddingRight: "40px" }}
                                          />
                                          <Image
                                            style={{ right: "15px", top: "12px" }}
                                            width={15}
                                            className="position-absolute"
                                            src={searchIcon}
                                          />
                                        </div>
                                        
                                        {historySearchTerm && (
                                          <Button 
                                            variant="light" 
                                            className="bg-white"
                                            style={{ padding: "10px 10px", borderRadius: "8px" }}
                                            onClick={() => setHistorySearchTerm("")}
                                            title="Clear Search"
                                          >
                                            <FcClearFilters className="fs-16" />
                                          </Button>
                                        )}
                                      </div>
                                    </div>

                                    <Table responsive hover className="mb-0 table-hover-border">
                                      <thead>
                                        <tr>
                                          <th>Sr No.</th>
                                          <th 
                                            onClick={() => handleHistorySort('exportedAt')}
                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                          >
                                            Exported At{' '}
                                            {historySortField === 'exportedAt' ? (
                                              historySortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />
                                            ) : (
                                              <FaSort className="text-muted" />
                                            )}
                                          </th>
                                          <th 
                                            onClick={() => handleHistorySort('status')}
                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                          >
                                            Status{' '}
                                            {historySortField === 'status' ? (
                                              historySortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />
                                            ) : (
                                              <FaSort className="text-muted" />
                                            )}
                                          </th>
                                          <th 
                                            onClick={() => handleHistorySort('fileName')}
                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                          >
                                            File Name{' '}
                                            {historySortField === 'fileName' ? (
                                              historySortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />
                                            ) : (
                                              <FaSort className="text-muted" />
                                            )}
                                          </th>
                                          <th 
                                            onClick={() => handleHistorySort('fileSizeBytes')}
                                            style={{ cursor: 'pointer', userSelect: 'none' }}
                                          >
                                            File Size{' '}
                                            {historySortField === 'fileSizeBytes' ? (
                                              historySortOrder === 'asc' ? <FaSortUp /> : <FaSortDown />
                                            ) : (
                                              <FaSort className="text-muted" />
                                            )}
                                          </th>
                                          <th>Error Message</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {getFilteredAndSortedHistory().length === 0 ? (
                                          <tr>
                                            <td colSpan="6" className="text-center py-4">
                                              <Image src={noRecordFound} width={80} className="mb-2" />
                                              <p className="mb-0 text-muted fs-14">
                                                {historySearchTerm
                                                  ? 'No history records match your search criteria'
                                                  : 'No history records found'}
                                              </p>
                                            </td>
                                          </tr>
                                        ) : (
                                          getFilteredAndSortedHistory().map((record, index) => (
                                            <tr key={record.id || index}>
                                              <td>{(historyPage * historySize) + index + 1}</td>
                                              <td>{record.exportedAt ? new Date(record.exportedAt).toLocaleString() : 'N/A'}</td>
                                              <td>
                                                <span
                                                  className={`badge badge-before position-relative ps-3 bg-${
                                                    record.status === 'SUCCESS' ? "success" : 
                                                    record.status === 'FAILED' ? "danger" : 
                                                    "warning"
                                                  }`}
                                                >
                                                  {record.status || 'N/A'}
                                                </span>
                                              </td>
                                              <td>{record.fileName || 'N/A'}</td>
                                              <td>{formatFileSize(record.fileSizeBytes)}</td>
                                              <td>
                                                <span 
                                                  className="text-muted fs-12" 
                                                  title={record.errorMessage}
                                                  style={{
                                                    maxWidth: '200px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    display: 'inline-block'
                                                  }}
                                                >
                                                  {record.errorMessage || '-'}
                                                </span>
                                              </td>
                                            </tr>
                                          ))
                                        )}
                                      </tbody>
                                    </Table>

                                    {/* Pagination */}
                                    {historyTotalPages > 1 && (
                                      <div className="d-flex justify-content-center mt-4">
                                        <nav>
                                          <ul className="pagination mb-2">
                                            <li className={`page-item ${historyPage === 0 ? 'disabled' : ''}`}>
                                              <button
                                                className="page-link"
                                                onClick={() => handleHistoryPageChange(0)}
                                                disabled={historyPage === 0}
                                              >
                                                &laquo;
                                              </button>
                                            </li>
                                            <li className={`page-item ${historyPage === 0 ? 'disabled' : ''}`}>
                                              <button
                                                className="page-link"
                                                onClick={() => handleHistoryPageChange(historyPage - 1)}
                                                disabled={historyPage === 0}
                                              >
                                                &lt;
                                              </button>
                                            </li>
                                            {(() => {
                                              let startPage = Math.max(historyPage - 1, 0);
                                              let endPage = Math.min(startPage + 2, historyTotalPages - 1);
                                              
                                              if (endPage === historyTotalPages - 1) {
                                                startPage = Math.max(endPage - 2, 0);
                                              }

                                              return [...Array(endPage - startPage + 1)].map((_, idx) => (
                                                <li
                                                  key={startPage + idx}
                                                  className={`page-item ${historyPage === startPage + idx ? 'active' : ''}`}
                                                >
                                                  <button
                                                    className="page-link"
                                                    onClick={() => handleHistoryPageChange(startPage + idx)}
                                                  >
                                                    {startPage + idx + 1}
                                                  </button>
                                                </li>
                                              ));
                                            })()}
                                            <li className={`page-item ${historyPage === historyTotalPages - 1 ? 'disabled' : ''}`}>
                                              <button
                                                className="page-link"
                                                onClick={() => handleHistoryPageChange(historyPage + 1)}
                                                disabled={historyPage === historyTotalPages - 1}
                                              >
                                                &gt;
                                              </button>
                                            </li>
                                            <li className={`page-item ${historyPage === historyTotalPages - 1 ? 'disabled' : ''}`}>
                                              <button
                                                className="page-link"
                                                onClick={() => handleHistoryPageChange(historyTotalPages - 1)}
                                                disabled={historyPage === historyTotalPages - 1}
                                              >
                                                &raquo;
                                              </button>
                                            </li>
                                          </ul>
                                        </nav>
                                      </div>
                                    )}
                                  </>
                                )}
                              </Card.Body>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </Tab>
                  )}
                </Tabs>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Delete Schedule Modal */}
      <Modal
        show={showDeleteScheduleModal}
        onHide={() => setShowDeleteScheduleModal(false)}
        centered
        size="md"
      >
        <Modal.Body className="text-center p-4">
          <h5 className="text-101828 mb-1 fw-600 ls-minus-0 fs-14">
            Confirm Delete
          </h5>
          <p className="fw-400 fs-12 mb-1">
            Are you sure you want to delete this schedule?
          </p>
          {scheduleToDelete && (
            <div className="mt-3">
              <p className="mb-1">
                <span className="fw-600">Frequency:</span> {scheduleToDelete.frequency}
              </p>
              <p className="mb-0">
                <span className="fw-600">Time:</span> {scheduleToDelete.scheduledTime}
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-none pt-0 p-3 border-0" style={{ justifyContent: "center !important" }}>
          <div className="d-flex gap-3 w-75">
            <Button
              variant="light br-radius-8p"
              className="flex-grow-1"
              onClick={() => setShowDeleteScheduleModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="flex-grow-1"
              onClick={confirmDeleteSchedule}
            >
              Yes, Delete
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Container>
  );
};

export default Reports;
